var _typeof = require("/var/lib/jenkins/jobs/prweb-front-end-build/workspace/tagged_builds/RELEASE-2.37.0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/typeof");

function _interopDefault(ex) {
  return ex && _typeof(ex) === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var PropTypes = _interopDefault(require('prop-types'));

var classNames = _interopDefault(require('classnames'));

var includes = _interopDefault(require('lodash/includes'));

var isFunction = _interopDefault(require('lodash/isFunction'));

var ReactDOM = _interopDefault(require('react-dom'));

var isNull = _interopDefault(require('lodash/isNull'));

var isBoolean = _interopDefault(require('lodash/isBoolean'));

var reactContainerQuery = require('@cision/react-container-query');

var intersection = _interopDefault(require('lodash/intersection'));

var nanoid = require('nanoid');

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children", "defaultExpandedPanel"];

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      defaultExpandedPanel = _ref.defaultExpandedPanel,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useState = React.useState(defaultExpandedPanel),
      expandedPanel = _useState[0],
      setExpandedPanel = _useState[1];

  var handleToggle = function handleToggle(panel, onToggle) {
    return function (event, expanded) {
      setExpandedPanel(expanded ? panel : null);

      if (onToggle) {
        onToggle(event, expanded);
      }
    };
  };

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps), children && React.Children.map(children, function (child, index) {
      return (
        /*#__PURE__*/
        React.cloneElement(child, _extends({}, child.props, {
          defaultExpanded: undefined,
          expanded: index === expandedPanel,
          onToggle: handleToggle(index, child.props.onToggle)
        }))
      );
    }))
  );
};

var styles = {
  "Avatar": "rvr-Avatar__2kq",
  "loading": "rvr-loading__36h",
  "imagePlaceholderShimmer": "rvr-imagePlaceholderShimmer__2dy",
  "disabled": "rvr-disabled__3ad",
  "disabledNoImage": "rvr-disabledNoImage__2Ap",
  "AvatarBadge": "rvr-AvatarBadge__3Up"
};
var _excluded$1 = ["position", "offset", "className", "style"];

var Addon = function Addon(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom-right' : _ref$position,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);

  var positions = React.useMemo(function () {
    var _ref2;

    var p = position.split('-');
    return _ref2 = {}, _ref2[p[0]] = offset + "px", _ref2[p[1]] = offset + "px", _ref2;
  }, [position, offset]);
  var badgeClassNames = classNames(styles.AvatarBadge, className);
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, rest, {
      className: badgeClassNames,
      style: _extends({}, positions, style)
    }))
  );
};

Addon.propTypes = {
  position: PropTypes.oneOf(['top-left', 'top-right', 'bottom-right', 'bottom-left', 'left-top', 'right-top', 'left-bottom', 'right-bottom']),
  offset: PropTypes.number
};
Addon.defaultProps = {
  position: 'bottom-right',
  offset: 0
};
var fontSizeBase = 14;
var sizeBase = 8;
var fontSizeMap = {
  sm: fontSizeBase * (12 / 14),
  md: fontSizeBase,
  h4: fontSizeBase * (16 / 14),
  h3: fontSizeBase * (24 / 14),
  h2: fontSizeBase * (32 / 14),
  h1: fontSizeBase * (40 / 14)
};
var fontSizes = Object.values(fontSizeMap);
var _excluded$2 = ["size", "loading", "name", "imageUrl", "disabled", "className", "children", "onLoad", "onError", "imageFetcher"];
var semanticSizes = {
  small: sizeBase * 5,
  medium: sizeBase * 7,
  large: sizeBase * 12
};

function defaultImageFetcher(_ref) {
  var onLoad = _ref.onLoad,
      onError = _ref.onError,
      src = _ref.src;
  var img = new Image();
  img.referrerPolicy = 'no-referrer';
  img.crossOrigin = 'Anonymous';

  img.onload = function () {
    var image = this;

    if ('naturalHeight' in this) {
      if (image.naturalHeight + image.naturalWidth === 0) {
        onError(new Error('Invalid Image'));
        return;
      }
    } else if (image.width + image.height === 0) {
      onError(new Error('Invalid Image'));
      return;
    }

    onLoad(src);
  };

  img.onerror = function (e) {
    onError(e);
  };

  if (src) img.src = src;
  return function () {
    img.onload = function () {};

    img.onerror = function () {};
  };
}

var Avatar = function Avatar(_ref2) {
  var _classNames;

  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'small' : _ref2$size,
      _ref2$loading = _ref2.loading,
      loading = _ref2$loading === void 0 ? false : _ref2$loading,
      _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? '' : _ref2$name,
      _ref2$imageUrl = _ref2.imageUrl,
      imageUrl = _ref2$imageUrl === void 0 ? '' : _ref2$imageUrl,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? null : _ref2$children,
      _ref2$onLoad = _ref2.onLoad,
      onLoad = _ref2$onLoad === void 0 ? null : _ref2$onLoad,
      _ref2$onError = _ref2.onError,
      onError = _ref2$onError === void 0 ? null : _ref2$onError,
      _ref2$imageFetcher = _ref2.imageFetcher,
      imageFetcher = _ref2$imageFetcher === void 0 ? defaultImageFetcher : _ref2$imageFetcher,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded$2);

  var mainClassName = classNames(styles.Avatar, className, (_classNames = {}, _classNames[styles.loading] = loading, _classNames[styles.disabled] = disabled && imageUrl, _classNames[styles.disabledNoImage] = disabled && !imageUrl, _classNames));
  var sizes = React.useMemo(function () {
    var pixelSize = size ? semanticSizes[size] || size : semanticSizes.small;
    return {
      width: pixelSize + "px",
      height: pixelSize + "px",
      fontSize: pixelSize / 2 + "px"
    };
  }, [size]);

  var _useState = React.useState(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  var initials = React.useMemo(function () {
    if (!name) return '';
    var nameParts = name.split(' ', 2);
    return nameParts.map(function (part) {
      var _char = part.codePointAt(0);

      if (_char === undefined) {
        return '';
      }

      return String.fromCodePoint(_char);
    }).join('');
  }, [name]);
  React.useEffect(function () {
    if (!imageUrl) return function () {};
    setLoaded(false);

    var handleLoad = function handleLoad(src) {
      setLoaded(true);
      if (onLoad) onLoad(src);
    };

    var handleError = function handleError(e) {
      setLoaded(false);
      if (onError) onError(e);
    };

    return imageFetcher({
      onLoad: handleLoad,
      onError: handleError,
      src: imageUrl
    });
  }, [imageFetcher, imageUrl, onError, onLoad]);

  var mainStyle = _extends({}, sizes, {
    backgroundImage: loaded && !loading ? "url(" + imageUrl + ")" : undefined
  }, rest.style);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      className: mainClassName,
      "aria-label": name ? "Profile image of " + name : '',
      "aria-hidden": !name
    }, rest, {
      style: mainStyle
    }), !loading && !loaded && initials, children)
  );
};

Avatar.Addon = Addon;
Avatar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  imageFetcher: PropTypes.func,
  imageUrl: PropTypes.string,
  loading: PropTypes.bool,
  name: PropTypes.string,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['small', 'medium', 'large'])])
};
Avatar.defaultProps = {
  children: null,
  className: '',
  disabled: false,
  imageFetcher: defaultImageFetcher,
  imageUrl: '',
  loading: false,
  name: '',
  onError: function onError() {},
  onLoad: function onLoad() {},
  size: 'small'
};
var styles$1 = {
  "Badge": "rvr-Badge__2ni",
  "dark": "rvr-dark__25p",
  "round": "rvr-round__1hB",
  "danger": "rvr-danger__3oG",
  "notify": "rvr-notify__1E-",
  "warning": "rvr-warning__371",
  "info": "rvr-info__27g",
  "success": "rvr-success__3iv"
};
var _excluded$3 = ["className", "tag", "round", "variant"];
var variants = ['dark', 'danger', 'notify', 'warning', 'info', 'success', ''];

var buildVariantClasses = function buildVariantClasses(list, variant) {
  return list.reduce(function (acc, item) {
    acc[styles$1[item]] = variant === item;
    return acc;
  }, {});
};

var Badge = function Badge(_ref) {
  var _classNames;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      _ref$round = _ref.round,
      round = _ref$round === void 0 ? null : _ref$round,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  var classes = classNames(className, styles$1.Badge, (_classNames = {}, _classNames[styles$1.round] = round, _classNames), buildVariantClasses(variants, variant));
  return (
    /*#__PURE__*/
    React__default.createElement(Tag, Object.assign({}, rest, {
      className: classes
    }))
  );
};

var styles$2 = {
  "BarStat": "rvr-BarStat__bgf",
  "Bar": "rvr-Bar__3vO",
  "Fill": "rvr-Fill__1O4",
  "label": "rvr-label__ol_"
};
var _excluded$4 = ["className", "width", "style"];

var BarGenerator = function BarGenerator(name, barClassname) {
  var GeneratedBar = function GeneratedBar(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === void 0 ? '' : _ref$className,
        _ref$width = _ref.width,
        widthProp = _ref$width === void 0 ? undefined : _ref$width,
        _ref$style = _ref.style,
        styleProp = _ref$style === void 0 ? {} : _ref$style,
        props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

    var width = widthProp;

    if (widthProp) {
      width = typeof widthProp === 'number' ? widthProp + "px" : widthProp;
    }

    var style = _extends({
      width: width
    }, styleProp);

    return (
      /*#__PURE__*/
      React__default.createElement("div", Object.assign({}, props, {
        style: style,
        className: classNames(barClassname, className)
      }))
    );
  };

  GeneratedBar.displayName = name;
  return GeneratedBar;
};

var Fill = BarGenerator('Bar.Fill', styles$2.Fill);
var Bar = BarGenerator('Bar', styles$2.Bar);
Bar.Fill = Fill;
var Context =
/*#__PURE__*/
React.createContext({});
var styles$3 = {
  "Addon": "rvr-Addon__354",
  "sm": "rvr-sm__3JT",
  "md": "rvr-md__1KT",
  "lg": "rvr-lg__wul"
};
var _excluded$5 = ["className", "size"];

var Addon$1 = function Addon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      customSize = _ref.size,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$5);

  var buttonContext = React.useContext(Context);
  var size = customSize || buttonContext.size || 'md';
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, {
      className: classNames(className, styles$3.Addon, styles$3[size])
    }))
  );
};

Addon$1.displayName = 'ButtonAddon';
var styles$4 = {
  "Button": "rvr-Button__1lS",
  "buttonBody": "rvr-buttonBody__2iL",
  "sm": "rvr-sm__FrE",
  "md": "rvr-md__3Zf",
  "lg": "rvr-lg__2D3",
  "circle": "rvr-circle__1_2",
  "focus": "rvr-focus__1_h",
  "disabled": "rvr-disabled__2hS",
  "outline": "rvr-outline__36j",
  "primary": "rvr-primary__2yV",
  "active": "rvr-active__1d4",
  "hover": "rvr-hover__3-m",
  "primary-alt": "rvr-primary-alt__3Rz",
  "secondary": "rvr-secondary__cZi",
  "tertiary": "rvr-tertiary__2Cb",
  "success": "rvr-success__3rt",
  "danger": "rvr-danger__1ni",
  "link": "rvr-link__79E",
  "text": "rvr-text__3os",
  "as-text": "rvr-as-text__3E_"
};
var _excluded$6 = ["children", "circle", "className", "forwardedRef", "hollow", "level", "outline", "size", "tag"];

var hasHref = function hasHref(props) {
  return 'href' in props && props.href !== undefined;
};

var states = ['hover', 'focus', 'active', 'disabled', 'checked'];

var Button = function Button(_ref) {
  var _ref$children = _ref.children,
      initChildren = _ref$children === void 0 ? null : _ref$children,
      _ref$circle = _ref.circle,
      circle = _ref$circle === void 0 ? undefined : _ref$circle,
      _ref$className = _ref.className,
      passedClassName = _ref$className === void 0 ? '' : _ref$className,
      forwardedRef = _ref.forwardedRef,
      _ref$hollow = _ref.hollow,
      DEPRECATED_hollow = _ref$hollow === void 0 ? false : _ref$hollow,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 'secondary' : _ref$level,
      _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? false : _ref$outline,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? null : _ref$tag,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$6);

  var children = React__default.Children.map(initChildren, function (child) {
    return typeof child === 'string' ?
    /*#__PURE__*/
    React__default.createElement("span", null, child) : child;
  });
  var truthyStateKeys = React.useMemo(function () {
    return states.filter(function (state) {
      return !!passedProps[state];
    });
  }, [passedProps]);
  var className = React.useMemo(function () {
    var _classNames;

    return classNames(passedClassName, styles$4.Button, styles$4[level], styles$4[size], (_classNames = {}, _classNames[styles$4['as-text']] = ['link', 'text'].indexOf(level) >= 0, _classNames[styles$4.circle] = circle, _classNames[styles$4.outline] = outline || DEPRECATED_hollow, _classNames[styles$4['primary-alt']] = level === 'teal', _classNames), truthyStateKeys.map(function (truthyStateKey) {
      return styles$4[truthyStateKey];
    }));
  }, [circle, DEPRECATED_hollow, level, outline, passedClassName, size, truthyStateKeys]);
  var Tag = 'button';

  if (tag) {
    Tag = tag;
  } else if (hasHref(passedProps)) {
    Tag = 'a';
  }

  return (
    /*#__PURE__*/
    React__default.createElement(Context.Provider, {
      value: {
        size: size
      }
    },
    /*#__PURE__*/
    React__default.createElement(Tag, Object.assign({
      className: className,
      ref: forwardedRef,
      type: Tag === 'button' ? 'button' : undefined
    }, passedProps), children))
  );
};

Button.Addon = Addon$1;
Button.WithRef =
/*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(Button, Object.assign({}, props, {
      forwardedRef: ref
    }))
  );
});
var styles$5 = {
  "Callout": "rvr-Callout__21l",
  "success": "rvr-success__1nh",
  "danger": "rvr-danger__JI_",
  "warning": "rvr-warning__1Ek",
  "borderless": "rvr-borderless__25O",
  "compact": "rvr-compact__2_J",
  "cancelable": "rvr-cancelable__2pz",
  "cancelButton": "rvr-cancelButton__SlC"
};
var iconColorsMap = {
  mainicon: 'currentColor',
  exchange: '#0071BB',
  facebook: '#3B579D',
  googleblue: '#4285F4',
  googlegreen: '#34A853',
  googleyellow: '#FBBC05',
  googlered: '#EA4335',
  googleplus: '#DB4437',
  instagram: '#0A0B09',
  linkedin: '#0077B5',
  outlook: '#EB3C00',
  pinterest: '#BD081C',
  redditred: '#FF4500',
  redditwhite: '#FFFFFE',
  retweet: '#677078',
  slackblue: '#36C5F0',
  slackgreen: '#2EB67D',
  slackred: '#E01E5A',
  slackyellow: '#ECB22E',
  twitch: '#6441A4',
  twitter: '#1DA1F2',
  twittercomment: '#677078',
  twitteremail: '#677078',
  twitterlike: '#677078',
  twitterverified: '#1CA1F2',
  youtube: 'red'
};
var _excluded$7 = ["fill"];

var AdEquiv = function AdEquiv(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M13.41,18.09 L13.41,20 L10.74,20 L10.74,18.07 C9.03,17.71 7.58,16.61 7.47,14.67 L9.43,14.67 C9.53,15.72 10.25,16.54 12.08,16.54 C14.04,16.54 14.48,15.56 14.48,14.95 C14.48,14.12 14.04,13.34 11.81,12.81 C9.33,12.21 7.63,11.19 7.63,9.14 C7.63,7.42 9.02,6.3 10.74,5.93 L10.74,4 L13.41,4 L13.41,5.95 C15.27,6.4 16.2,7.81 16.26,9.34 L14.3,9.34 C14.25,8.23 13.66,7.47 12.08,7.47 C10.58,7.47 9.68,8.15 9.68,9.11 C9.68,9.95 10.33,10.5 12.35,11.02 C14.37,11.54 16.53,12.41 16.53,14.93 C16.52,16.76 15.15,17.76 13.41,18.09 Z"
    }))
  );
};

AdEquiv.propTypes = {
  fill: PropTypes.string
};
AdEquiv.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$8 = ["fill"];

var AddToGroup = function AddToGroup(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$8);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
    }))
  );
};

AddToGroup.propTypes = {
  fill: PropTypes.string
};
AddToGroup.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$9 = ["fill"];

var AddCircle = function AddCircle(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$9);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    }))
  );
};

AddCircle.propTypes = {
  fill: PropTypes.string
};
AddCircle.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$a = ["fill"];

var AddDocument = function AddDocument(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$a);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14 2H4v20h16V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
    }))
  );
};

AddDocument.propTypes = {
  fill: PropTypes.string
};
AddDocument.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$b = ["fill"];

var AddToGroup$1 = function AddToGroup(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$b);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86 0 1.07-.34 2.04-.9 2.86.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
    }))
  );
};

AddToGroup$1.propTypes = {
  fill: PropTypes.string
};
AddToGroup$1.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$c = ["fill"];

var ArrowBack = function ArrowBack(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
    }))
  );
};

ArrowBack.propTypes = {
  fill: PropTypes.string
};
ArrowBack.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$d = ["fill"];

var ArrowDown = function ArrowDown(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$d);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
    }))
  );
};

ArrowDown.propTypes = {
  fill: PropTypes.string
};
ArrowDown.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$e = ["fill"];

var ArrowDropDown = function ArrowDropDown(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$e);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 10l5 5 5-5z"
    }))
  );
};

ArrowDropDown.propTypes = {
  fill: PropTypes.string
};
ArrowDropDown.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$f = ["fill"];

var ArrowDropUp = function ArrowDropUp(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$f);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 14l5-5 5 5z"
    }))
  );
};

ArrowDropUp.propTypes = {
  fill: PropTypes.string
};
ArrowDropUp.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$g = ["fill"];

var ArrowForward = function ArrowForward(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    }))
  );
};

ArrowForward.propTypes = {
  fill: PropTypes.string
};
ArrowForward.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$h = ["fill"];

var ArrowLeft = function ArrowLeft(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$h);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14 7l-5 5 5 5z"
    }))
  );
};

ArrowLeft.propTypes = {
  fill: PropTypes.string
};
ArrowLeft.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$i = ["fill"];

var ArrowRight = function ArrowRight(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$i);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 17l5-5-5-5z"
    }))
  );
};

ArrowRight.propTypes = {
  fill: PropTypes.string
};
ArrowRight.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$j = ["fill"];

var ArrowUp = function ArrowUp(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
    }))
  );
};

ArrowUp.propTypes = {
  fill: PropTypes.string
};
ArrowUp.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$k = ["fill"];

var Attach = function Attach(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$k);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    }))
  );
};

Attach.propTypes = {
  fill: PropTypes.string
};
Attach.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$l = ["fill"];

var Bell = function Bell(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$l);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill,
      fillRule: "nonzero",
      d: "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V2.5h-3v2.18C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
    })))
  );
};

Bell.propTypes = {
  fill: PropTypes.string
};
Bell.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$m = ["fill"];

var Blocked = function Blocked(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
    }))
  );
};

Blocked.propTypes = {
  fill: PropTypes.string
};
Blocked.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$n = ["fill"];

var Blog = function Blog(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$n);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("defs", null,
    /*#__PURE__*/
    React__default.createElement("path", {
      id: "a",
      d: "M10 4v1.5c.286 0 .572.014.855.043.284.029.564.069.84.121a8.729 8.729 0 011.61.5 8.872 8.872 0 011.437.781 7.577 7.577 0 011.266 1.047 7.65 7.65 0 011.047 1.266 8.512 8.512 0 011.28 3.047c.053.276.093.556.122.84.029.283.043.569.043.855H20c0-1.38-.262-2.677-.785-3.89a10.114 10.114 0 00-2.145-3.18 10.114 10.114 0 00-3.18-2.145A9.717 9.717 0 0010 4zm0 3v1.5a5.504 5.504 0 013.05.918 5.564 5.564 0 011.531 1.531 5.372 5.372 0 01.814 1.969c.07.352.105.712.105 1.082H17c0-.969-.184-1.878-.55-2.727a7.172 7.172 0 00-1.497-2.226 7.172 7.172 0 00-2.226-1.496A6.794 6.794 0 0010 7zm1.5 3l-1 1L7 12l-3 6.5.398.398 3.633-3.64a.527.527 0 01-.011-.063.527.527 0 00-.012-.062.603.603 0 00-.004-.067.969.969 0 01.074-.457c.052-.12.123-.226.211-.32.094-.088.2-.159.32-.21A.969.969 0 019 14c.14 0 .27.026.39.078.12.052.227.123.32.211.09.094.16.2.212.32.052.12.078.25.078.391 0 .14-.026.27-.078.39-.052.12-.123.227-.211.32-.094.09-.2.16-.32.212a.969.969 0 01-.457.074.603.603 0 00-.067-.004.527.527 0 00-.062-.012.527.527 0 01-.063-.011l-3.64 3.633L5.5 20l6.5-3 1-3.5 1-1-2.5-2.5z"
    })),
    /*#__PURE__*/
    React__default.createElement("use", {
      xlinkHref: "#a"
    }))
  );
};

Blog.propTypes = {
  fill: PropTypes.string
};
Blog.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$o = ["fill"];

var Bolt = function Bolt(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$o);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98 0 5.51 4.47 9.98 9.98 9.98 5.51 0 9.98-4.47 9.98-9.98 0-5.51-4.47-9.98-9.98-9.98zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z"
    }))
  );
};

Bolt.propTypes = {
  fill: PropTypes.string
};
Bolt.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$p = ["fill"];

var Bookmark = function Bookmark(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$p);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 18l2 1V1H7v2h12v15zM17 5H3v18l7-3 7 3V5z"
    }))
  );
};

Bookmark.propTypes = {
  fill: PropTypes.string
};
Bookmark.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$q = ["fill"];

var Business = function Business(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 7V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2h-8zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm9 12h-7v-2h2v-2h-2v-2h2v-2h-2V9h7c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1zm-1-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
    }))
  );
};

Business.propTypes = {
  fill: PropTypes.string
};
Business.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$r = ["fill"];

var Calendar = function Calendar(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$r);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M17 13h-5v5h5v-5zM16 2v2H8V2H6v2H3.01L3 22h18V4h-3V2h-2zm3 18H5V9h14v11z"
    }))
  );
};

Calendar.propTypes = {
  fill: PropTypes.string
};
Calendar.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$s = ["fill"];

var Campaign = function Campaign(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("defs", null,
    /*#__PURE__*/
    React__default.createElement("path", {
      id: "a",
      d: "M20 4v16L8 14.667V9.333L20 4zM6.667 9.333v8H4v-8h2.667zM17.333 8l-6.666 2.878v2.455L17.333 16V8z"
    })),
    /*#__PURE__*/
    React__default.createElement("use", {
      fill: fill,
      xlinkHref: "#a"
    }))
  );
};

Campaign.propTypes = {
  fill: PropTypes.string
};
Campaign.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$t = ["fill"];

var ChartArea = function ChartArea(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fillRule: "nonzero"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2 20h20V9.92L20 9l-7 8-4-4-7 5.99z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2 16l7-7 4 3 7-8 2 3v3l-2-1-7 8-4-4-7 6z"
    })))
  );
};

ChartArea.propTypes = {
  fill: PropTypes.string
};
ChartArea.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$u = ["fill"];

var ChartBarsHorz = function ChartBarsHorz(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$u);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15 5v3H4V5h11zm5 5.6v2.8H4v-2.8h16zm-9.143 5.6V19H4v-2.8h6.857z"
    }))
  );
};

ChartBarsHorz.propTypes = {
  fill: PropTypes.string
};
ChartBarsHorz.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$v = ["fill"];

var ChartBarsStacked = function ChartBarsStacked(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$v);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M5 11.2h3V20H5v-8.8zM10.6 9h2.8v11h-2.8V9zm5.6 6H19v5h-2.8v-5zm0-7H19v6h-2.8V8zm-5.6-4h2.8v4h-2.8V4zM5 6.2h3V10H5V6.2z"
    }))
  );
};

ChartBarsStacked.propTypes = {
  fill: PropTypes.string
};
ChartBarsStacked.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$w = ["fill"];

var ChartBarsVert = function ChartBarsVert(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M5 9h3v11H5V9zm5.6-5h2.8v16h-2.8V4zm5.6 9.143H19V20h-2.8v-6.857z"
    }))
  );
};

ChartBarsVert.propTypes = {
  fill: PropTypes.string
};
ChartBarsVert.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$x = ["fill"];

var ChartBarsBorder = function ChartBarsBorder(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$x);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }))
  );
};

ChartBarsBorder.propTypes = {
  fill: PropTypes.string
};
ChartBarsBorder.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$y = ["fill"];

var ChartBubble = function ChartBubble(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$y);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14.8 16a2 2 0 110 4 2 2 0 010-4zm-7.6-4.8a3.2 3.2 0 110 6.4 3.2 3.2 0 010-6.4zm8-7.2a4.8 4.8 0 110 9.6 4.8 4.8 0 010-9.6z"
    }))
  );
};

ChartBubble.propTypes = {
  fill: PropTypes.string
};
ChartBubble.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$z = ["fill"];

var ChartDonut = function ChartDonut(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$z);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M13 5.08A7 7 0 0118.92 11h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13A7 7 0 0113 18.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
    }))
  );
};

ChartDonut.propTypes = {
  fill: PropTypes.string
};
ChartDonut.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$A = ["fill"];

var ChartDonut$1 = function ChartDonut(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$A);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
    }))
  );
};

ChartDonut$1.propTypes = {
  fill: PropTypes.string
};
ChartDonut$1.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$B = ["fill"];

var ChartSparkAndBar = function ChartSparkAndBar(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$B);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fillRule: "nonzero"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M5 9h3v11H5V9zm5.6-5h2.8v16h-2.8V4zm5.6 9.143H19V20h-2.8v-6.857z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
    })))
  );
};

ChartSparkAndBar.propTypes = {
  fill: PropTypes.string
};
ChartSparkAndBar.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$C = ["fill"];

var ChartSparkline = function ChartSparkline(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$C);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
    }))
  );
};

ChartSparkline.propTypes = {
  fill: PropTypes.string
};
ChartSparkline.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$D = ["fill"];

var Chat = function Chat(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$D);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    }))
  );
};

Chat.propTypes = {
  fill: PropTypes.string
};
Chat.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$E = ["fill"];

var Chat$1 = function Chat(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$E);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }))
  );
};

Chat$1.propTypes = {
  fill: PropTypes.string
};
Chat$1.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$F = ["fill"];

var Chevron = function Chevron(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$F);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }))
  );
};

Chevron.propTypes = {
  fill: PropTypes.string
};
Chevron.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$G = ["fill"];

var ChevronLeft = function ChevronLeft(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$G);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }))
  );
};

ChevronLeft.propTypes = {
  fill: PropTypes.string
};
ChevronLeft.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$H = ["fill"];

var ChevronRight = function ChevronRight(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$H);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill,
      d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }))
  );
};

ChevronRight.propTypes = {
  fill: PropTypes.string
};
ChevronRight.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$I = ["fill"];

var ChevronUp = function ChevronUp(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$I);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }))
  );
};

ChevronUp.propTypes = {
  fill: PropTypes.string
};
ChevronUp.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$J = ["fill"];

var Chat$2 = function Chat(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$J);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    }))
  );
};

Chat$2.propTypes = {
  fill: PropTypes.string
};
Chat$2.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$K = ["fill"];

var Clock = function Clock(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$K);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
    }))
  );
};

Clock.propTypes = {
  fill: PropTypes.string
};
Clock.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$L = ["fill"];

var Close = function Close(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$L);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }))
  );
};

Close.propTypes = {
  fill: PropTypes.string
};
Close.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$M = ["fill"];

var Close$1 = function Close(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$M);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4v-2z"
    }))
  );
};

Close$1.propTypes = {
  fill: PropTypes.string
};
Close$1.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$N = ["fill"];

var ContactList = function ContactList(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$N);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
    }))
  );
};

ContactList.propTypes = {
  fill: PropTypes.string
};
ContactList.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$O = ["fill"];

var Copy = function Copy(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$O);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
    }))
  );
};

Copy.propTypes = {
  fill: PropTypes.string
};
Copy.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$P = ["fill"];

var Dashboard = function Dashboard(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$P);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M0 0h24v24H0z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill,
      fillRule: "nonzero",
      d: "M3 11h12V3H3v8zm0 10h8v-8H3v8zm10 0h8v-8h-8v8zm4-18v8h4V3h-4z"
    })))
  );
};

Dashboard.propTypes = {
  fill: PropTypes.string
};
Dashboard.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$Q = ["fill"];

var Delete = function Delete(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
    }))
  );
};

Delete.propTypes = {
  fill: PropTypes.string
};
Delete.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$R = ["fill"];

var Download = function Download(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$R);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
    }))
  );
};

Download.propTypes = {
  fill: PropTypes.string
};
Download.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$S = ["fill"];

var Dinner = function Dinner(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$S);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
    }))
  );
};

Dinner.propTypes = {
  fill: PropTypes.string
};
Dinner.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$T = ["fill"];

var Drinks = function Drinks(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$T);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
    }))
  );
};

Drinks.propTypes = {
  fill: PropTypes.string
};
Drinks.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$U = ["fill"];

var Edit = function Edit(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$U);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }))
  );
};

Edit.propTypes = {
  fill: PropTypes.string
};
Edit.defaultProps = {
  fill: iconColorsMap.mainicon
};

var EllipsisV = function EllipsisV(props) {
  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }))
  );
};

var _excluded$V = ["fill"];

var Enlarge = function Enlarge(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$V);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
    }))
  );
};

Enlarge.propTypes = {
  fill: PropTypes.string
};
Enlarge.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$W = ["fill"];

var Filter = function Filter(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$W);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }))
  );
};

Filter.propTypes = {
  fill: PropTypes.string
};
Filter.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$X = ["fill"];

var Flag = function Flag(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$X);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
    }))
  );
};

Flag.propTypes = {
  fill: PropTypes.string
};
Flag.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$Y = ["fill"];

var Folder = function Folder(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Y);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    }))
  );
};

Folder.propTypes = {
  fill: PropTypes.string
};
Folder.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$Z = ["fill"];

var FolderOpen = function FolderOpen(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$Z);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
    }))
  );
};

FolderOpen.propTypes = {
  fill: PropTypes.string
};
FolderOpen.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$_ = ["fill"];

var FormatBold = function FormatBold(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$_);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
    }))
  );
};

FormatBold.propTypes = {
  fill: PropTypes.string
};
FormatBold.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$$ = ["fill"];

var FormatBulletNumbered = function FormatBulletNumbered(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$$);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
    }))
  );
};

FormatBulletNumbered.propTypes = {
  fill: PropTypes.string
};
FormatBulletNumbered.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$10 = ["fill"];

var FormatBulletPlain = function FormatBulletPlain(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$10);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
    }))
  );
};

FormatBulletPlain.propTypes = {
  fill: PropTypes.string
};
FormatBulletPlain.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$11 = ["fill"];

var FormatClear = function FormatClear(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$11);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
    }))
  );
};

FormatClear.propTypes = {
  fill: PropTypes.string
};
FormatClear.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$12 = ["fill"];

var FormatCode = function FormatCode(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$12);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    }))
  );
};

FormatCode.propTypes = {
  fill: PropTypes.string
};
FormatCode.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$13 = ["fill"];

var FormatItalic = function FormatItalic(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$13);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
    }))
  );
};

FormatItalic.propTypes = {
  fill: PropTypes.string
};
FormatItalic.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$14 = ["fill"];

var FormatParagraphCenter = function FormatParagraphCenter(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$14);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
    }))
  );
};

FormatParagraphCenter.propTypes = {
  fill: PropTypes.string
};
FormatParagraphCenter.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$15 = ["fill"];

var FormatParagraphJustify = function FormatParagraphJustify(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$15);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
    }))
  );
};

FormatParagraphJustify.propTypes = {
  fill: PropTypes.string
};
FormatParagraphJustify.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$16 = ["fill"];

var FormatParagraphLeft = function FormatParagraphLeft(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$16);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
    }))
  );
};

FormatParagraphLeft.propTypes = {
  fill: PropTypes.string
};
FormatParagraphLeft.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$17 = ["fill"];

var FormatParagraphRight = function FormatParagraphRight(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$17);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
    }))
  );
};

FormatParagraphRight.propTypes = {
  fill: PropTypes.string
};
FormatParagraphRight.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$18 = ["fill"];

var Paper = function Paper(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$18);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
    }))
  );
};

Paper.propTypes = {
  fill: PropTypes.string
};
Paper.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$19 = ["fill"];

var FormattingTextColor = function FormattingTextColor(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$19);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fillRule: "nonzero"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M0 20h24v4H0zM11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
    })))
  );
};

FormattingTextColor.propTypes = {
  fill: PropTypes.string
};
FormattingTextColor.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1a = ["fill"];

var FormattingText = function FormattingText(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1a);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
    }))
  );
};

FormattingText.propTypes = {
  fill: PropTypes.string
};
FormattingText.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1b = ["fill"];

var FormattingUnderline = function FormattingUnderline(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1b);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
    }))
  );
};

FormattingUnderline.propTypes = {
  fill: PropTypes.string
};
FormattingUnderline.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1c = ["fill"];

var Globe = function Globe(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1c);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
    }))
  );
};

Globe.propTypes = {
  fill: PropTypes.string
};
Globe.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1d = ["fill"];

var GripperCorner = function GripperCorner(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1d);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20.828 22.657l2.829-2.829-1.414-1.414-2.829 2.829 1.414 1.414zM7.393 19.12l1.415 1.415L21.536 7.808 20.12 6.393 7.393 19.121zm7.071 2.829l8.486-8.486-1.414-1.414-8.486 8.486 1.414 1.414z"
    }))
  );
};

GripperCorner.propTypes = {
  fill: PropTypes.string
};
GripperCorner.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1e = ["fill"];

var Gripper = function Gripper(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1e);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }))
  );
};

Gripper.propTypes = {
  fill: PropTypes.string
};
Gripper.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1f = ["fill"];

var Hamburger = function Hamburger(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1f);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }))
  );
};

Hamburger.propTypes = {
  fill: PropTypes.string
};
Hamburger.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1g = ["fill"];

var Hide = function Hide(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1g);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    }))
  );
};

Hide.propTypes = {
  fill: PropTypes.string
};
Hide.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1h = ["fill"];

var Home = function Home(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1h);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
    }))
  );
};

Home.propTypes = {
  fill: PropTypes.string
};
Home.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1i = ["fill"];

var Hyperlink = function Hyperlink(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1i);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    }))
  );
};

Hyperlink.propTypes = {
  fill: PropTypes.string
};
Hyperlink.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1j = ["fill"];

var Image$1 = function Image(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1j);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    }))
  );
};

Image$1.propTypes = {
  fill: PropTypes.string
};
Image$1.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1k = ["fill"];

var Inbox = function Inbox(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1k);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
    }))
  );
};

Inbox.propTypes = {
  fill: PropTypes.string
};
Inbox.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1l = ["fill"];

var Info2 = function Info2(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1l);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    }))
  );
};

Info2.propTypes = {
  fill: PropTypes.string
};
Info2.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1m = ["fill"];

var Info = function Info(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1m);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    }))
  );
};

Info.propTypes = {
  fill: PropTypes.string
};
Info.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1n = ["fill"];

var Kebabs = function Kebabs(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1n);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }))
  );
};

Kebabs.propTypes = {
  fill: PropTypes.string
};
Kebabs.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1o = ["fill"];

var KeyMessage = function KeyMessage(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1o);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
    }))
  );
};

KeyMessage.propTypes = {
  fill: PropTypes.string
};
KeyMessage.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1p = ["fill"];

var Key = function Key(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1p);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20.75 9.5h-9.42a5 5 0 100 5H12l1.25-1.25h1.25v1.25h1.25L17 13.25h1.25v1.25h1.25L22 12l-1.25-2.5zm-15 4.268a1.768 1.768 0 110-3.536 1.768 1.768 0 010 3.536zM12 11.375v-.625h7.5l.313.625H12z"
    }))
  );
};

Key.propTypes = {
  fill: PropTypes.string
};
Key.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1q = ["fill"];

var Lightning = function Lightning(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 2v11h3v9l7-12h-4l3-8z"
    }))
  );
};

Lightning.propTypes = {
  fill: PropTypes.string
};
Lightning.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1r = ["fill"];

var ListAdd = function ListAdd(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1r);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
    }))
  );
};

ListAdd.propTypes = {
  fill: PropTypes.string
};
ListAdd.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1s = ["fill"];

var ListAlt = function ListAlt(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1s);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 5v14H5V5h14zm1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6v-2zM7 7h2v2H7V7zm0 4h2v2H7v-2zm0 4h2v2H7v-2z"
    }))
  );
};

ListAlt.propTypes = {
  fill: PropTypes.string
};
ListAlt.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1t = ["fill"];

var ListVerfied = function ListVerfied(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1t);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
    }))
  );
};

ListVerfied.propTypes = {
  fill: PropTypes.string
};
ListVerfied.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1u = ["fill"];

var ListViewActive = function ListViewActive(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1u);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 11.01L3 11v2h18v-1.99zM3 16h12v2H3v-2zM21 6H3v2.01L21 8V6z"
    }))
  );
};

ListViewActive.propTypes = {
  fill: PropTypes.string
};
ListViewActive.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1v = ["fill"];

var Location = function Location(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1v);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
    }))
  );
};

Location.propTypes = {
  fill: PropTypes.string
};
Location.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1w = ["fill"];

var Lock = function Lock(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1w);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 8h-3V6.21c0-2.61-1.91-4.94-4.51-5.19A5.008 5.008 0 007 6v2H4v14h16V8zm-8 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM9 8V6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9z"
    }))
  );
};

Lock.propTypes = {
  fill: PropTypes.string
};
Lock.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1x = ["fill"];

var Lunch = function Lunch(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1x);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15v-2z"
    }))
  );
};

Lunch.propTypes = {
  fill: PropTypes.string
};
Lunch.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1y = ["fill"];

var Magazine = function Magazine(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1y);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M14.333 9.875h1.334a.268.268 0 00.13-.034.297.297 0 00.104-.096.387.387 0 00.073-.137.561.561 0 000-.341.387.387 0 00-.073-.137.297.297 0 00-.104-.096.268.268 0 00-.13-.034h-1.334a.268.268 0 00-.13.034.297.297 0 00-.104.096.387.387 0 00-.073.137.561.561 0 000 .341c.017.055.042.1.073.137a.297.297 0 00.104.096.268.268 0 00.13.034zm0-2h1.334a.268.268 0 00.13-.034.297.297 0 00.104-.096.387.387 0 00.073-.137.561.561 0 000-.341.387.387 0 00-.073-.137.297.297 0 00-.104-.096.268.268 0 00-.13-.034h-1.334a.268.268 0 00-.13.034.297.297 0 00-.104.096.387.387 0 00-.073.137.561.561 0 000 .341c.017.055.042.1.073.137a.297.297 0 00.104.096.268.268 0 00.13.034zm0 4h1.334a.268.268 0 00.13-.034.297.297 0 00.104-.096.387.387 0 00.073-.137.561.561 0 000-.341.387.387 0 00-.073-.137.297.297 0 00-.104-.096.268.268 0 00-.13-.034h-1.334a.268.268 0 00-.13.034.297.297 0 00-.104.096.387.387 0 00-.073.137.561.561 0 000 .341c.017.055.042.1.073.137a.297.297 0 00.104.096.268.268 0 00.13.034zm-5.933 4h7.2a.373.373 0 00.281-.13.372.372 0 00.088-.137.476.476 0 000-.341.372.372 0 00-.088-.137.373.373 0 00-.281-.13H8.4a.373.373 0 00-.281.13.372.372 0 00-.088.137.476.476 0 000 .341c.021.055.05.1.088.137a.373.373 0 00.281.13zm0-2h7.2a.373.373 0 00.281-.13.372.372 0 00.088-.137.476.476 0 000-.341.372.372 0 00-.088-.137.373.373 0 00-.281-.13H8.4a.373.373 0 00-.281.13.372.372 0 00-.088.137.476.476 0 000 .341c.021.055.05.1.088.137a.373.373 0 00.281.13zM17.571 5H7.714a2.6 2.6 0 00-.388.027c-.12.019-.234.048-.342.09a1.27 1.27 0 00-.294.143 1.307 1.307 0 00-.442.451c-.054.091-.1.191-.14.3-.037.11-.063.226-.081.35A2.713 2.713 0 006 6.75v11.813c0 .059.011.116.033.17a.37.37 0 00.094.137c.036.041.08.073.134.096.054.023.11.034.168.034h9.428a.423.423 0 00.168-.034.363.363 0 00.133-.096.37.37 0 00.094-.137.448.448 0 00.034-.17v-.438h1.285a.423.423 0 00.168-.034.363.363 0 00.134-.096.37.37 0 00.094-.137.448.448 0 00.033-.17V5.438a.448.448 0 00-.033-.171.37.37 0 00-.094-.137.363.363 0 00-.134-.096A.423.423 0 0017.57 5zM17 17H7V6.846c0-.075.003-.145.01-.211a.835.835 0 01.036-.179.878.878 0 01.058-.149.376.376 0 01.085-.109.405.405 0 01.11-.089.856.856 0 01.144-.063A1.555 1.555 0 017.833 6H17v11zM12.583 7H8.417c-.057 0-.11.01-.16.033a.43.43 0 00-.133.09.353.353 0 00-.091.13.42.42 0 00-.033.164v4.166c0 .057.01.11.033.16a.43.43 0 00.09.133c.035.04.079.07.13.091a.42.42 0 00.164.033h4.166c.057 0 .11-.01.16-.033a.43.43 0 00.133-.09.353.353 0 00.091-.13.42.42 0 00.033-.164V7.417c0-.057-.01-.11-.033-.16a.43.43 0 00-.09-.133.353.353 0 00-.13-.091.42.42 0 00-.164-.033z"
    }))
  );
};

Magazine.propTypes = {
  fill: PropTypes.string
};
Magazine.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1z = ["fill"];

var MailArchive = function MailArchive(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1z);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
    }))
  );
};

MailArchive.propTypes = {
  fill: PropTypes.string
};
MailArchive.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1A = ["fill"];

var MailBulk = function MailBulk(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1A);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M22 6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8-4v2H2v14H0V4c0-1.1.9-2 2-2h12zm8 6v2l-8 5-8-5V8l8 5 8-5z"
    }))
  );
};

MailBulk.propTypes = {
  fill: PropTypes.string
};
MailBulk.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1B = ["fill"];

var MailDraft = function MailDraft(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1B);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
    }))
  );
};

MailDraft.propTypes = {
  fill: PropTypes.string
};
MailDraft.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1C = ["fill"];

var MailPersonal = function MailPersonal(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1C);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
    }))
  );
};

MailPersonal.propTypes = {
  fill: PropTypes.string
};
MailPersonal.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1D = ["fill"];

var Mail = function Mail(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1D);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }))
  );
};

Mail.propTypes = {
  fill: PropTypes.string
};
Mail.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1E = ["fill"];

var MarkAsUnread = function MarkAsUnread(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1E);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 7H10v6H8V5h6V1H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2z"
    }))
  );
};

MarkAsUnread.propTypes = {
  fill: PropTypes.string
};
MarkAsUnread.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1F = ["fill"];

var Meatballs = function Meatballs(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1F);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }))
  );
};

Meatballs.propTypes = {
  fill: PropTypes.string
};
Meatballs.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1G = ["fill"];

var MediaList = function MediaList(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1G);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2 5h6v5H2zM10 5h12v2H10zM10 8h8v2h-8zM2 14h6v5H2zM10 14h12v2H10zM10 17h8v2h-8z"
    }))
  );
};

MediaList.propTypes = {
  fill: PropTypes.string
};
MediaList.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1H = ["fill"];

var MentionGroup = function MentionGroup(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1H);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M1 5h2v14H1V5zm4 0h2v14H5V5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 15h5v2h-5v-2zm0-4h10v2H11v-2zm0-4h10v2H11V7z"
    }))
  );
};

MentionGroup.propTypes = {
  fill: PropTypes.string
};
MentionGroup.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1I = ["fill"];

var MessageBubble = function MessageBubble(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1I);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    }))
  );
};

MessageBubble.propTypes = {
  fill: PropTypes.string
};
MessageBubble.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1J = ["fill"];

var Mouse = function Mouse(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1J);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M17.339 13.943l-2.767-4.001a4.13 4.13 0 00-1.203-1.157 4.89 4.89 0 00-1.555-.648 5.375 5.375 0 00-1.726-.114 5.035 5.035 0 00-1.698.465c-.115-.182-.22-.36-.316-.535a4.505 4.505 0 01-.243-.512 2.785 2.785 0 01-.162-.488 2.066 2.066 0 01-.054-.457c0-.136.01-.28.031-.43a1.71 1.71 0 01.122-.438 1.24 1.24 0 01.234-.383c.102-.114.234-.206.397-.273a.645.645 0 00.09-.047.177.177 0 00.054-.028.78.78 0 00.054-.043.419.419 0 00.13-.164.47.47 0 000-.379.494.494 0 00-.13-.168.83.83 0 00-.158-.094.531.531 0 00-.176-.046.757.757 0 00-.189.007.647.647 0 00-.171.055 2.375 2.375 0 00-.622.38 2.06 2.06 0 00-.45.542 2.54 2.54 0 00-.275.688 3.412 3.412 0 00-.095.82c0 .204.024.41.072.622.048.21.114.423.198.637.09.219.196.439.316.66.12.222.255.444.405.668-.39.318-.704.678-.942 1.079a3.582 3.582 0 00-.428 2.602c.097.454.289.883.577 1.29l2.767 4.001c.216.313.47.59.762.832.29.243.608.447.95.614.349.161.712.285 1.09.371a5.192 5.192 0 001.763.094 5.16 5.16 0 001.194-.281c.192-.07.381-.156.568-.254a4.411 4.411 0 001.356-1.071c.358-.427.608-.891.753-1.391a3.489 3.489 0 00.094-1.528 3.548 3.548 0 00-.617-1.497zm-5.831-.64a.71.71 0 01-.126.062 1.17 1.17 0 01-.266.066.816.816 0 01-.14.012 1.087 1.087 0 01-.469-.11.921.921 0 01-.369-.288l-1.325-1.813a.777.777 0 01-.14-.317.693.693 0 01.014-.324.736.736 0 01.149-.305.932.932 0 01.284-.235.976.976 0 01.365-.128c.129-.019.256-.015.383.011.126.026.243.07.351.133a.867.867 0 01.27.242l1.325 1.806a.84.84 0 01.14.324c.021.112.02.22-.005.324a.84.84 0 01-.157.305.932.932 0 01-.284.235z"
    }))
  );
};

Mouse.propTypes = {
  fill: PropTypes.string
};
Mouse.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1K = ["fill"];

var MoveToInbox = function MoveToInbox(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1K);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
    }))
  );
};

MoveToInbox.propTypes = {
  fill: PropTypes.string
};
MoveToInbox.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1L = ["fill"];

var Move = function Move(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1L);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
    }))
  );
};

Move.propTypes = {
  fill: PropTypes.string
};
Move.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1M = ["fill"];

var NewTab = function NewTab(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1M);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }))
  );
};

NewTab.propTypes = {
  fill: PropTypes.string
};
NewTab.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1N = ["fill"];

var News = function News(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1N);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M18 3v18H4a2 2 0 01-2-2V3h16zm4 6v10a2 2 0 01-1.85 1.995L20 21V9h2zM11 9H4v9a1 1 0 00.883.993L5 19h6V9zm5 8h-3v2h3v-2zm0-8h-3v6h3V9zm0-4H4v2h12V5z"
    }))
  );
};

News.propTypes = {
  fill: PropTypes.string
};
News.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1O = ["fill"];

var Note = function Note(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1O);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
    }))
  );
};

Note.propTypes = {
  fill: PropTypes.string
};
Note.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1P = ["fill"];

var Numbers = function Numbers(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1P);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19 4c.552 0 1 .445 1 1v14c0 .552-.445 1-1 1H5c-.552 0-1-.445-1-1V5c0-.552.445-1 1-1h14zM7 8H6v1h1v7h1V8.997C8 8.453 7.552 8 7 8zm5.001 0h-1.002a.996.996 0 00-.992.883L10 9h2v2h-1a.997.997 0 00-.993.883L10 12v3c0 .517.386.936.882.993L11 16h1.002a.996.996 0 00.992-.883L13 15h-2v-3h1a1 1 0 00.993-.892l.007-.117V9.009A.999.999 0 0012.001 8zm5 0h-1.002A.997.997 0 0015 9h2v2h-2v1h2v3h-2l.007.116c.057.493.48.884.992.884h1.002a.995.995 0 00.999-.997V8.997c0-.544-.447-.997-.999-.997z"
    }))
  );
};

Numbers.propTypes = {
  fill: PropTypes.string
};
Numbers.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1Q = ["fill"];

var Phone = function Phone(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    }))
  );
};

Phone.propTypes = {
  fill: PropTypes.string
};
Phone.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1R = ["fill"];

var Pin = function Pin(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1R);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M13.286 3L12 4.286l1.286 1.285-5.143 5.143H4.286l3.857 3.857L3 19.714V21h1.286l5.143-5.143 3.857 3.857-.161-3.857 5.304-5.143L19.714 12 21 10.714 13.286 3zm-2.572 10.286L9.43 12l5.142-5.143 1.286 1.286-5.143 5.143z"
    }))
  );
};

Pin.propTypes = {
  fill: PropTypes.string
};
Pin.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1S = ["fill"];

var PitchStage = function PitchStage(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1S);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M6.433 10.857L2 15.43 6.433 20v-3.429h7.79v-2.285h-7.79v-3.429zM22 8.571L17.567 4v3.429h-7.79v2.285h7.79v3.429L22 8.57z"
    }))
  );
};

PitchStage.propTypes = {
  fill: PropTypes.string
};
PitchStage.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1T = ["fill"];

var Play = function Play(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1T);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }))
  );
};

Play.propTypes = {
  fill: PropTypes.string
};
Play.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1U = ["fill"];

var Refresh = function Refresh(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1U);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }))
  );
};

Refresh.propTypes = {
  fill: PropTypes.string
};
Refresh.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1V = ["fill"];

var ReplyAll = function ReplyAll(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1V);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
    }))
  );
};

ReplyAll.propTypes = {
  fill: PropTypes.string
};
ReplyAll.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1W = ["fill"];

var Reply = function Reply(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1W);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
    }))
  );
};

Reply.propTypes = {
  fill: PropTypes.string
};
Reply.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1X = ["fill"];

var Report = function Report(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1X);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M13 5v1h6l-.001 9H20v2h-5l2 2-1 1-3-3v3h-2v-3l-3 3-1-1 2-2H4v-2h1V6h6V5h2zm4 3H7v7h9.999L17 8z"
    }))
  );
};

Report.propTypes = {
  fill: PropTypes.string
};
Report.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1Y = ["fill"];

var Restore = function Restore(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Y);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    }))
  );
};

Restore.propTypes = {
  fill: PropTypes.string
};
Restore.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1Z = ["fill"];

var Search = function Search(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1Z);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }))
  );
};

Search.propTypes = {
  fill: PropTypes.string
};
Search.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1_ = ["fill"];

var Send = function Send(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1_);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
    }))
  );
};

Send.propTypes = {
  fill: PropTypes.string
};
Send.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$1$ = ["fill"];

var SentimentNegative = function SentimentNegative(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$1$);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-5c1.11 0 2.13.33 2.98.89-.15.16-.89 1-1.01 1.14-.58-.34-1.24-.53-1.97-.53s-1.39.19-1.98.52c-1-1.12-.04-.05-1.01-1.14.86-.55 1.88-.88 2.99-.88zm3.5-7a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    }))
  );
};

SentimentNegative.propTypes = {
  fill: PropTypes.string
};
SentimentNegative.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$20 = ["fill"];

var SentimentPositive = function SentimentPositive(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$20);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1.97-4.53c1 1.13.04.06 1.01 1.15a5.49 5.49 0 01-5.95.01c.15-.17.89-1.01 1.01-1.15.58.34 1.23.52 1.96.52s1.38-.18 1.97-.53zM15.5 8a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    }))
  );
};

SentimentPositive.propTypes = {
  fill: PropTypes.string
};
SentimentPositive.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$21 = ["fill"];

var SentimentVeryNegative = function SentimentVeryNegative(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$21);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2 1.48 0 2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-7 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    }))
  );
};

SentimentVeryNegative.propTypes = {
  fill: PropTypes.string
};
SentimentVeryNegative.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$22 = ["fill"];

var SentimentVeryPositive = function SentimentVeryPositive(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$22);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6h10c-.78 2.34-2.72 4-5 4-2.204 0-4.09-1.551-4.918-3.768L7 14h10zm8.5-6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-7 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    }))
  );
};

SentimentVeryPositive.propTypes = {
  fill: PropTypes.string
};
SentimentVeryPositive.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$23 = ["fill"];

var Sentiment = function Sentiment(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$23);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-3-5h6v1.5H9V15zm6.5-4a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-7 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
    }))
  );
};

Sentiment.propTypes = {
  fill: PropTypes.string
};
Sentiment.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$24 = ["fill"];

var SettingsGear = function SettingsGear(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$24);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M18.885 12.877c.035-.28.058-.573.058-.877 0-.304-.023-.596-.07-.877l1.956-1.486a.456.456 0 00.116-.573l-1.852-3.117a.477.477 0 00-.567-.202l-2.302.9a6.83 6.83 0 00-1.563-.877l-.347-2.385A.458.458 0 0013.851 3H10.15a.446.446 0 00-.452.382L9.35 5.768a7.012 7.012 0 00-1.562.878l-2.303-.9a.464.464 0 00-.567.202L3.067 9.064a.428.428 0 00.115.573l1.956 1.486a5.502 5.502 0 00-.081.877c0 .293.023.596.07.877L3.17 14.364a.456.456 0 00-.116.573l1.852 3.116c.115.203.358.27.567.203l2.302-.9c.486.36.995.652 1.563.878l.347 2.384a.467.467 0 00.463.383h3.702c.232 0 .429-.157.452-.383l.347-2.384a7.012 7.012 0 001.562-.878l2.303.9c.208.079.451 0 .567-.203l1.851-3.116a.428.428 0 00-.115-.573l-1.933-1.486zM12 15.375c-1.91 0-3.472-1.519-3.472-3.375S10.091 8.625 12 8.625c1.91 0 3.472 1.519 3.472 3.375S13.909 15.375 12 15.375z"
    }))
  );
};

SettingsGear.propTypes = {
  fill: PropTypes.string
};
SettingsGear.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$25 = ["fill"];

var Share2 = function Share2(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$25);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z"
    }))
  );
};

Share2.propTypes = {
  fill: PropTypes.string
};
Share2.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$26 = ["fill"];

var ShareWith = function ShareWith(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$26);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }))
  );
};

ShareWith.propTypes = {
  fill: PropTypes.string
};
ShareWith.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$27 = ["fill"];

var Shared = function Shared(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$27);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }))
  );
};

Shared.propTypes = {
  fill: PropTypes.string
};
Shared.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$28 = ["fill"];

var Smartphone = function Smartphone(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$28);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M5 1v22h14V1H5zm12 18H7V5h10v14z"
    }))
  );
};

Smartphone.propTypes = {
  fill: PropTypes.string
};
Smartphone.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$29 = ["fill"];

var SortAsc = function SortAsc(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$29);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 8h6V6H3v2zm0 8v2h18v-2H3zm0-3h12v-2H3v2z"
    }))
  );
};

SortAsc.propTypes = {
  fill: PropTypes.string
};
SortAsc.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2a = ["fill"];

var SortDesc = function SortDesc(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2a);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
    }))
  );
};

SortDesc.propTypes = {
  fill: PropTypes.string
};
SortDesc.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2b = ["fill"];

var SpikeAlert = function SpikeAlert(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2b);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 23c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99zm7-6v-6c0-3.35-2.36-6.15-5.5-6.83V1.5h-3v2.67C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2zm-6-1h-2v-2h2v2zm0-4h-2V8h2v4z"
    }))
  );
};

SpikeAlert.propTypes = {
  fill: PropTypes.string
};
SpikeAlert.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2c = ["fill"];

var StarEmpty = function StarEmpty(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2c);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    }))
  );
};

StarEmpty.propTypes = {
  fill: PropTypes.string
};
StarEmpty.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2d = ["fill"];

var StarFilled = function StarFilled(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2d);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    }))
  );
};

StarFilled.propTypes = {
  fill: PropTypes.string
};
StarFilled.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2e = ["fill"];

var Station = function Station(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2e);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 002 2h16a2 2 0 002-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
    }))
  );
};

Station.propTypes = {
  fill: PropTypes.string
};
Station.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2f = ["fill"];

var SyncDisabled = function SyncDisabled(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2f);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36a7.925 7.925 0 001.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 016 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24A6.003 6.003 0 0118 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 00-1.14-9.87L20 4z"
    }))
  );
};

SyncDisabled.propTypes = {
  fill: PropTypes.string
};
SyncDisabled.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2g = ["fill"];

var SyncError = function SyncError(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2g);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
    }))
  );
};

SyncError.propTypes = {
  fill: PropTypes.string
};
SyncError.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2h = ["fill"];

var Sync = function Sync(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2h);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    }))
  );
};

Sync.propTypes = {
  fill: PropTypes.string
};
Sync.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2i = ["fill"];

var Tag = function Tag(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2i);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
    }))
  );
};

Tag.propTypes = {
  fill: PropTypes.string
};
Tag.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2j = ["fill"];

var ThumbsUp = function ThumbsUp(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2j);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
    }))
  );
};

ThumbsUp.propTypes = {
  fill: PropTypes.string
};
ThumbsUp.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2k = ["fill"];

var TimerOff = function TimerOff(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2k);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M19.04 4.55l-1.42 1.42a9.012 9.012 0 00-10.57-.49l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45A8.878 8.878 0 0021 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03A8.905 8.905 0 003 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
    }))
  );
};

TimerOff.propTypes = {
  fill: PropTypes.string
};
TimerOff.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2l = ["fill"];

var Timer = function Timer(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2l);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }))
  );
};

Timer.propTypes = {
  fill: PropTypes.string
};
Timer.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2m = ["fill"];

var Tv = function Tv(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2m);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
    }))
  );
};

Tv.propTypes = {
  fill: PropTypes.string
};
Tv.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2n = ["fill"];

var Upload = function Upload(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2n);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
    }))
  );
};

Upload.propTypes = {
  fill: PropTypes.string
};
Upload.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2o = ["fill"];

var UserRelationship = function UserRelationship(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2o);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7a2.5 2.5 0 000 5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
    }))
  );
};

UserRelationship.propTypes = {
  fill: PropTypes.string
};
UserRelationship.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2p = ["fill"];

var User = function User(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2p);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }))
  );
};

User.propTypes = {
  fill: PropTypes.string
};
User.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2q = ["fill"];

var UserEmpty = function UserEmpty(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }))
  );
};

UserEmpty.propTypes = {
  fill: PropTypes.string
};
UserEmpty.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2r = ["fill"];

var ViewGrid = function ViewGrid(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2r);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
    }))
  );
};

ViewGrid.propTypes = {
  fill: PropTypes.string
};
ViewGrid.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2s = ["fill"];

var ViewStream = function ViewStream(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2s);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
    }))
  );
};

ViewStream.propTypes = {
  fill: PropTypes.string
};
ViewStream.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2t = ["fill"];

var ViewTable = function ViewTable(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2t);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
    }))
  );
};

ViewTable.propTypes = {
  fill: PropTypes.string
};
ViewTable.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2u = ["fill"];

var ViewVerticalSplit = function ViewVerticalSplit(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2u);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
    }))
  );
};

ViewVerticalSplit.propTypes = {
  fill: PropTypes.string
};
ViewVerticalSplit.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2v = ["fill"];

var View = function View(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2v);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }))
  );
};

View.propTypes = {
  fill: PropTypes.string
};
View.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2w = ["fill"];

var Warning = function Warning(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2w);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }))
  );
};

Warning.propTypes = {
  fill: PropTypes.string
};
Warning.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2x = ["fill"];

var Web = function Web(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2x);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
    }))
  );
};

Web.propTypes = {
  fill: PropTypes.string
};
Web.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2y = ["fill"];

var Work = function Work(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2y);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M22 6h-6V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H2v15h20V6zm-8 0h-4V4h4v2z"
    }))
  );
};

Work.propTypes = {
  fill: PropTypes.string
};
Work.defaultProps = {
  fill: iconColorsMap.mainicon
};
var _excluded$2z = ["fill"];

var Exchange = function Exchange(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2z);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M13.083 4.096L3 5.712v12.653l10.083 1.616V4.096zM5.95 14.99V8.353l3.68-.365v1.343l-2.243.146v1.536l2.087-.05v1.332l-2.087-.02v1.578l2.39.126v1.343L5.95 14.99zm8.084-7.796v9.69H20.1c.496 0 .899-.373.899-.833V8.027c0-.46-.403-.833-.9-.833h-6.065z"
    }))
  );
};

Exchange.propTypes = {
  fill: PropTypes.string
};
Exchange.defaultProps = {
  fill: iconColorsMap.exchange
};
var _excluded$2A = ["fill"];

var Facebook = function Facebook(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2A);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M18.003 3H5.997c-.41 0-.798.08-1.164.237a3.036 3.036 0 00-.954.642 3.04 3.04 0 00-.642.954A2.905 2.905 0 003 5.997v12.006c0 .41.08.798.237 1.164.159.367.372.685.642.954.27.27.587.483.954.642.366.158.754.237 1.164.237H12v-7.875H9.75v-2.25H12V9.187a2.755 2.755 0 01.826-1.986 2.755 2.755 0 011.986-.826h2.813v2.25h-2.813a.566.566 0 00-.22.044.476.476 0 00-.175.123.476.476 0 00-.123.176.566.566 0 00-.044.22v1.687h3.094l-.563 2.25H14.25V21h3.753c.41 0 .798-.08 1.164-.237a3.03 3.03 0 00.954-.642c.27-.27.483-.587.642-.954.158-.366.237-.754.237-1.164V5.997c0-.41-.08-.798-.237-1.164a3.036 3.036 0 00-.642-.954 3.036 3.036 0 00-.954-.642A2.905 2.905 0 0018.003 3z"
    }))
  );
};

Facebook.propTypes = {
  fill: PropTypes.string
};
Facebook.defaultProps = {
  fill: iconColorsMap.facebook
};
var _excluded$2B = ["fill"];

var Google = function Google(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2B);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(3 3)"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[0],
      d: "M20.64 12.205c0-.639-.057-1.252-.164-1.841H12v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[1],
      d: "M12 21c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H3.957v2.332A8.997 8.997 0 0012 21z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[2],
      d: "M6.964 13.71A5.41 5.41 0 016.682 12c0-.593.102-1.17.282-1.71V7.958H3.957A8.996 8.996 0 003 12c0 1.452.348 2.827.957 4.042l3.007-2.332z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[3],
      d: "M12 6.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C16.463 3.891 14.426 3 12 3a8.997 8.997 0 00-8.043 4.958l3.007 2.332C7.672 8.163 9.656 6.58 12 6.58z"
    })))
  );
};

Google.propTypes = {
  fill: PropTypes.array
};
Google.defaultProps = {
  fill: [iconColorsMap.googleblue, iconColorsMap.googlegreen, iconColorsMap.googleyellow, iconColorsMap.googlered]
};
var _excluded$2C = ["fill"];

var GooglePlus = function GooglePlus(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2C);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 20 20",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M10,18c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z M16.2,9.3h-1.5V7.8h-1.1v1.5h-1.5v1.1h1.5v1.5 h1.1v-1.5h1.5V9.3z M7.8,10.7L7.8,10.7l2,0c-0.1,0.6-0.6,1.5-2,1.5c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2c0.7,0,1.1,0.3,1.4,0.5l1-1 C9.6,6.7,8.8,6.4,7.8,6.4c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6c2.1,0,3.5-1.5,3.5-3.6c0-0.3,0-0.5-0.1-0.7H7.8V10.7z"
    }))
  );
};

GooglePlus.propTypes = {
  fill: PropTypes.string
};
GooglePlus.defaultProps = {
  fill: iconColorsMap.googleplus
};
var _excluded$2D = ["fill"];

var Instagram = function Instagram(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2D);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M11.014 3h1.972c1.568.004 1.912.017 2.725.054.958.044 1.612.196 2.184.419.592.23 1.094.537 1.594 1.038.5.5.809 1.002 1.039 1.594.222.572.374 1.226.418 2.184.037.813.05 1.157.053 2.725v1.972c-.003 1.568-.016 1.912-.053 2.725-.044.958-.196 1.612-.418 2.184a4.412 4.412 0 01-1.039 1.594c-.5.5-1.002.809-1.594 1.039-.572.222-1.226.374-2.184.418-.96.044-1.267.054-3.711.054s-2.75-.01-3.71-.054c-.959-.044-1.613-.196-2.185-.418a4.412 4.412 0 01-1.594-1.039c-.5-.5-.809-1.002-1.038-1.594-.223-.572-.375-1.226-.419-2.184-.037-.813-.05-1.157-.053-2.725v-1.972c.003-1.568.016-1.912.053-2.725.044-.958.196-1.612.419-2.184A4.411 4.411 0 014.51 4.51c.5-.5 1.002-.809 1.594-1.038.572-.223 1.226-.375 2.184-.419.813-.037 1.157-.05 2.725-.053h1.972zm1.524 1.622h-1.075c-1.916.001-2.227.012-3.1.052-.877.04-1.354.187-1.67.31a2.79 2.79 0 00-1.036.673c-.315.315-.51.615-.673 1.035-.123.317-.27.794-.31 1.671-.04.873-.05 1.184-.052 3.1v1.075c.001 1.915.012 2.226.052 3.099.04.877.187 1.354.31 1.67.163.421.358.72.673 1.036.315.315.615.51 1.035.673.317.123.794.27 1.671.31.873.04 1.184.05 3.1.052h1.075c1.915-.001 2.226-.012 3.099-.052.877-.04 1.354-.187 1.67-.31a2.79 2.79 0 001.036-.673c.315-.315.51-.615.673-1.035.123-.317.27-.794.31-1.671.04-.873.05-1.184.052-3.1v-1.074c-.001-1.916-.012-2.227-.052-3.1-.04-.877-.187-1.354-.31-1.67a2.788 2.788 0 00-.673-1.036 2.788 2.788 0 00-1.035-.673c-.317-.123-.794-.27-1.671-.31-.873-.04-1.184-.05-3.1-.052zM12 7.378a4.622 4.622 0 110 9.244 4.622 4.622 0 010-9.244zM12 9a3 3 0 100 6 3 3 0 000-6zm4.804-2.884a1.08 1.08 0 110 2.16 1.08 1.08 0 010-2.16z"
    }))
  );
};

Instagram.propTypes = {
  fill: PropTypes.string
};
Instagram.defaultProps = {
  fill: iconColorsMap.instagram
};
var _excluded$2E = ["fill"];

var LinkedIn = function LinkedIn(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2E);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M19.669 3c.688 0 1.256.511 1.324 1.165l.007.133v15.404c0 .672-.525 1.225-1.195 1.292l-.136.007H4.329a1.319 1.319 0 01-1.322-1.166L3 19.702V4.298a1.31 1.31 0 011.193-1.291L4.328 3h15.34zM8.339 9.748H5.668v8.59h2.67v-8.59zm6.797-.213c-1.298 0-2.17.712-2.526 1.388h-.036V9.748h-2.561v8.59h2.669V14.09c0-1.12.212-2.206 1.601-2.206 1.37 0 1.387 1.281 1.387 2.278v4.178h2.67v-4.712c0-2.313-.5-4.092-3.204-4.092zM7.003 5.478a1.548 1.548 0 100 3.095 1.548 1.548 0 000-3.095z"
    }))
  );
};

LinkedIn.propTypes = {
  fill: PropTypes.string
};
LinkedIn.defaultProps = {
  fill: iconColorsMap.linkedin
};
var _excluded$2F = ["fill"];

var Outlook = function Outlook(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2F);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M4 17.7V6.6L14.24 3 20 4.8v14.4L14.24 21 4 17.7l10.24.9V6L7.52 7.2v9z"
    }))
  );
};

Outlook.propTypes = {
  fill: PropTypes.string
};
Outlook.defaultProps = {
  fill: iconColorsMap.outlook
};
var _excluded$2G = ["fill"];

var Pinterest = function Pinterest(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2G);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M12 3c-1.242 0-2.41.236-3.502.708a9.106 9.106 0 00-2.861 1.929 9.106 9.106 0 00-1.93 2.86A8.743 8.743 0 003 12c0 .955.14 1.866.422 2.733a8.935 8.935 0 001.186 2.391 8.908 8.908 0 001.807 1.934c.7.556 1.469.999 2.307 1.327a9.919 9.919 0 01-.08-1.275 6.69 6.69 0 01.018-.68 4.85 4.85 0 01.088-.63l.237-.997c.118-.489.235-.991.352-1.507l.325-1.371.14-.598-.039-.097a3.15 3.15 0 01-.184-.694 3.448 3.448 0 01-.04-.545c0-.316.043-.608.128-.874.084-.267.2-.497.347-.69a1.67 1.67 0 01.518-.457c.2-.112.41-.167.633-.167.193 0 .362.033.505.1.144.068.263.16.356.278a1.1 1.1 0 01.211.4c.047.155.07.317.07.487 0 .194-.027.409-.083.646-.056.238-.121.485-.198.743a67.91 67.91 0 01-.241.8c-.085.275-.16.545-.224.808a1.322 1.322 0 00-.005.633 1.266 1.266 0 00.725.866c.188.085.39.127.607.127.404 0 .778-.1 1.12-.298.343-.2.643-.48.901-.844.252-.363.45-.799.593-1.305a6.131 6.131 0 00.216-1.675c0-.539-.093-1.032-.277-1.48a3.428 3.428 0 00-.77-1.156 3.539 3.539 0 00-1.19-.752 4.152 4.152 0 00-1.516-.268c-.645 0-1.217.11-1.718.33a3.98 3.98 0 00-1.28.874 3.82 3.82 0 00-.795 1.253 3.936 3.936 0 00-.276 1.445 3.525 3.525 0 00.202 1.152c.058.181.129.35.21.505.083.155.17.289.264.4a.323.323 0 01.04.066.272.272 0 01.022.189l-.066.264a22.81 22.81 0 00-.075.307 11.347 11.347 0 00-.114.448.485.485 0 01-.04.102.134.134 0 01-.057.057.244.244 0 01-.092 0 .521.521 0 01-.11-.035 2.261 2.261 0 01-.76-.58 4.055 4.055 0 01-.576-.862 4.874 4.874 0 01-.365-1.015 4.425 4.425 0 01-.127-1.033c0-.709.127-1.391.382-2.048a4.994 4.994 0 011.138-1.74c.499-.498 1.118-.898 1.86-1.2.74-.301 1.597-.452 2.57-.452.78 0 1.506.13 2.18.391.674.26 1.26.625 1.758 1.094a4.96 4.96 0 011.608 3.709c0 .774-.116 1.502-.347 2.184a5.577 5.577 0 01-.971 1.78c-.416.504-.91.902-1.481 1.195a4.033 4.033 0 01-1.868.44 2.837 2.837 0 01-1.266-.308 2.303 2.303 0 01-.483-.33 1.359 1.359 0 01-.316-.4l-.075.278c-.05.184-.104.397-.163.637l-.189.716a32.09 32.09 0 01-.136.514 5.244 5.244 0 01-.21.611 9.495 9.495 0 01-.29.637c-.1.211-.206.412-.317.602-.112.19-.211.36-.3.506.212.064.426.123.643.175.216.053.436.094.659.124A8.586 8.586 0 0012 21c1.242 0 2.41-.236 3.502-.708a9.106 9.106 0 002.861-1.929 9.106 9.106 0 001.93-2.86A8.743 8.743 0 0021 12c0-1.242-.236-2.41-.708-3.502a9.106 9.106 0 00-1.929-2.861 9.106 9.106 0 00-2.86-1.93A8.743 8.743 0 0012 3z"
    }))
  );
};

Pinterest.propTypes = {
  fill: PropTypes.string
};
Pinterest.defaultProps = {
  fill: iconColorsMap.pinterest
};
var _excluded$2H = ["fill"];

var Reddit = function Reddit(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2H);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[0],
      d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[1],
      d: "M14.75 14.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm.22 2.053c-.853.852-2.488.918-2.969.918-.48 0-2.115-.066-2.967-.918a.324.324 0 01.458-.458c.538.538 1.688.728 2.51.728.821 0 1.972-.19 2.51-.728a.324.324 0 01.458.458zM8 13.25a1.251 1.251 0 012.5 0 1.25 1.25 0 01-2.5 0zM19.998 12a1.75 1.75 0 00-2.964-1.259c-1.196-.863-2.844-1.42-4.68-1.485l.797-3.75 2.605.553A1.247 1.247 0 0018.25 6a1.246 1.246 0 00-2.366-.552l-2.908-.619a.312.312 0 00-.37.24l-.891 4.186c-1.863.052-3.537.61-4.749 1.483a1.75 1.75 0 10-1.926 2.858c-.027.174-.042.35-.042.529 0 2.692 3.134 4.875 7 4.875s7-2.183 7-4.875c0-.178-.014-.353-.041-.526A1.75 1.75 0 0019.998 12z"
    })))
  );
};

Reddit.propTypes = {
  fill: PropTypes.array
};
Reddit.defaultProps = {
  fill: [iconColorsMap.redditred, iconColorsMap.redditwhite]
};
var _excluded$2I = ["fill"];

var Slack = function Slack(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2I);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24"
    }, props),
    /*#__PURE__*/
    React__default.createElement("g", {
      fill: "none"
    },
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[0],
      d: "M6.832 14.351c0 1.03-.842 1.873-1.872 1.873a1.877 1.877 0 01-1.873-1.873c0-1.03.842-1.872 1.873-1.872h1.872v1.872zm.944 0c0-1.03.842-1.872 1.872-1.872 1.031 0 1.873.841 1.873 1.872v4.689c0 1.03-.842 1.872-1.873 1.872a1.877 1.877 0 01-1.872-1.872V14.35z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[1],
      d: "M9.648 6.832A1.877 1.877 0 017.776 4.96c0-1.031.842-1.873 1.872-1.873 1.031 0 1.873.842 1.873 1.873v1.872H9.648zm0 .944c1.031 0 1.873.842 1.873 1.872 0 1.031-.842 1.873-1.873 1.873H4.96a1.877 1.877 0 01-1.873-1.873c0-1.03.842-1.872 1.873-1.872h4.688z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[2],
      d: "M17.167 9.648c0-1.03.842-1.872 1.873-1.872 1.03 0 1.872.842 1.872 1.872 0 1.031-.842 1.873-1.872 1.873h-1.873V9.648zm-.943 0c0 1.031-.842 1.873-1.873 1.873a1.877 1.877 0 01-1.872-1.873V4.96c0-1.031.841-1.873 1.872-1.873 1.03 0 1.873.842 1.873 1.873v4.688z"
    }),
    /*#__PURE__*/
    React__default.createElement("path", {
      fill: fill[3],
      d: "M14.351 17.167c1.03 0 1.873.842 1.873 1.873 0 1.03-.842 1.872-1.873 1.872a1.877 1.877 0 01-1.872-1.872v-1.873h1.872zm0-.943a1.877 1.877 0 01-1.872-1.873c0-1.03.841-1.872 1.872-1.872h4.689c1.03 0 1.872.841 1.872 1.872 0 1.03-.842 1.873-1.872 1.873H14.35z"
    })))
  );
};

Slack.propTypes = {
  fill: PropTypes.array
};
Slack.defaultProps = {
  fill: [iconColorsMap.slackred, iconColorsMap.slackblue, iconColorsMap.slackgreen, iconColorsMap.slackyellow]
};
var _excluded$2J = ["fill"];

var Twitch = function Twitch(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2J);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M4.266 3L3 6.09v12.626h4.5V21h2.531l2.39-2.284h3.657L21 14.015V3H4.266zm15.046 10.209L16.5 15.896H12l-2.39 2.283v-2.283H5.812V4.612h13.5v8.597zM16.5 7.701v4.702h-1.688V7.701H16.5zm-4.5 0v4.702h-1.688V7.701H12z"
    }))
  );
};

Twitch.propTypes = {
  fill: PropTypes.string
};
Twitch.defaultProps = {
  fill: iconColorsMap.twitch
};
var _excluded$2K = ["fill"];

var Twitter = function Twitter(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2K);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M22 5.924a9.58 9.58 0 01-.562.22 12.11 12.11 0 01-.58.19 8.804 8.804 0 01-1.212.234 4.84 4.84 0 00.591-.434 3.97 3.97 0 00.918-1.148c.12-.221.217-.449.288-.683a7.701 7.701 0 01-1.914.82c-.228.065-.455.12-.683.166a4.418 4.418 0 00-.62-.532 3.99 3.99 0 00-.718-.405 3.725 3.725 0 00-.801-.264 4.184 4.184 0 00-.86-.088c-.566 0-1.098.107-1.596.322a4.147 4.147 0 00-1.304.88 4.147 4.147 0 00-.879 1.303 3.988 3.988 0 00-.322 1.597 5.987 5.987 0 00.02.478l.039.23c.013.074.029.15.049.23a11.73 11.73 0 01-4.756-1.28 11.767 11.767 0 01-2.012-1.32 11.513 11.513 0 01-1.69-1.689 3.527 3.527 0 00-.41.977c-.052.169-.09.345-.112.527a4.484 4.484 0 00-.034.556c0 .359.042.702.127 1.03.084.33.208.64.37.933.157.293.348.562.572.806.225.244.477.46.757.65a4.162 4.162 0 01-.977-.157 3.096 3.096 0 01-.454-.151 4.834 4.834 0 01-.434-.21v.049c0 .501.084.975.254 1.42.169.447.4.845.693 1.197.293.358.64.66 1.04.903.4.244.835.412 1.304.503a3.646 3.646 0 01-.259.069 1.84 1.84 0 01-.269.039 3.895 3.895 0 01-1.132-.005 4.906 4.906 0 00-.186-.025c.13.404.32.778.566 1.123.248.345.538.645.87.899a4.017 4.017 0 002.393.82 7.78 7.78 0 01-1.119.742c-.394.215-.806.4-1.235.557a8.25 8.25 0 01-2.744.459h-.245c-.084 0-.166-.003-.244-.01a81.704 81.704 0 01-.249-.02A2.825 2.825 0 012 18.405a11.628 11.628 0 002.959 1.358c.527.162 1.07.285 1.626.366.557.081 1.125.122 1.704.122 1.888 0 3.558-.353 5.01-1.06 1.452-.706 2.672-1.619 3.662-2.739a11.882 11.882 0 002.241-3.76c.511-1.386.767-2.757.767-4.11a2.12 2.12 0 00-.005-.138 1.918 1.918 0 01-.005-.136V8.18a.966.966 0 00-.01-.137c.202-.143.396-.296.581-.459.186-.163.366-.332.542-.508.17-.176.332-.361.489-.556A9.69 9.69 0 0022 5.924z"
    }))
  );
};

Twitter.propTypes = {
  fill: PropTypes.string
};
Twitter.defaultProps = {
  fill: iconColorsMap.twitter
};
var _excluded$2L = ["fill"];

var YouTube = function YouTube(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2L);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 20 20",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M12.27 5c1.138.007 5.543.053 6.762.403.775.222 1.385.875 1.592 1.705C21 8.612 21 11.75 21 11.75s0 3.138-.376 4.642c-.207.83-.817 1.483-1.592 1.705C17.63 18.5 12 18.5 12 18.5s-5.629 0-7.032-.403c-.775-.222-1.385-.875-1.592-1.705-.324-1.297-.369-3.807-.375-4.475v-.334c.006-.668.05-3.178.375-4.475.207-.83.817-1.483 1.592-1.705 1.219-.35 5.624-.396 6.762-.402zm-2.11 3.92v5.66l4.704-2.83-4.705-2.83z"
    }))
  );
};

YouTube.propTypes = {
  fill: PropTypes.string
};
YouTube.defaultProps = {
  fill: iconColorsMap.youtube
};
var _excluded$2M = ["fill"];

var Retweet = function Retweet(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2M);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M15.942 6c1.38 0 2.504 1.173 2.504 2.617v7.597l1.699-1.776a.487.487 0 01.708 0 .54.54 0 010 .74l-2.554 2.67a.487.487 0 01-.709 0l-2.553-2.67a.54.54 0 010-.74.487.487 0 01.708 0l1.7 1.776V8.617c0-.866-.675-1.57-1.503-1.57h-4.44A.512.512 0 0111 6.523c0-.289.224-.524.501-.524zm-10.24.154a.483.483 0 01.707 0l2.555 2.668a.54.54 0 010 .74.488.488 0 01-.71 0L6.556 7.788v7.597c0 .865.674 1.569 1.503 1.569h4.44c.276 0 .501.235.501.523 0 .29-.225.523-.501.523h-4.44c-1.38 0-2.505-1.173-2.505-2.615V7.788l-1.7 1.774a.483.483 0 01-.707 0 .54.54 0 010-.74z"
    }))
  );
};

Retweet.propTypes = {
  fill: PropTypes.string
};
Retweet.defaultProps = {
  fill: iconColorsMap.retweet
};
var _excluded$2N = ["fill"];

var TwitterComment = function TwitterComment(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2N);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M16.1558462,14.2023077 C15.3513846,14.8829231 12.7086154,16.6156923 11.3549231,17.4933846 L11.3549231,15.234 C11.3549231,14.9410769 11.1169231,14.702 10.824,14.702 L10.5418462,14.702 C7.94646154,14.702 6.06292308,12.9476923 6.06292308,10.53 C6.06292308,8.02507692 8.02507692,6.06292308 10.5289231,6.06292308 L13.4678462,6.06938462 L13.4689231,6.06938462 C15.9738462,6.06938462 17.9338462,8.03046154 17.936,10.5332308 C17.936,11.8869231 17.2693846,13.2578462 16.1558462,14.2023077 M13.4710769,5.00646154 L13.4710769,5.00646154 L10.5310769,5 L10.53,5 L10.5289231,5 C7.42846154,5 5,7.42846154 5,10.53 C5,13.4344615 7.25830769,15.6378462 10.292,15.7541538 L10.292,18.468 C10.292,18.5444615 10.3221538,18.6704615 10.376,18.7544615 C10.4772308,18.9127692 10.6484615,19 10.824,19 C10.922,19 11.0210769,18.9730769 11.1093846,18.916 C11.2967692,18.7975385 15.6981538,15.9813846 16.8429231,15.0132308 C18.1912308,13.8716923 18.9967692,12.2003077 19,10.5396923 L19,10.5364615 L19,10.5332308 L19,10.5278462 C18.9956923,7.43169231 16.5683077,5.00753846 13.4710769,5.00646154"
    }))
  );
};

TwitterComment.propTypes = {
  fill: PropTypes.string
};
TwitterComment.defaultProps = {
  fill: iconColorsMap.twittercomment
};
var _excluded$2O = ["fill"];

var TwitterEmail = function TwitterEmail(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2O);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("defs", null,
    /*#__PURE__*/
    React__default.createElement("path", {
      id: "share-by-email-a",
      d: "M17.4250665,17.006959 L6.57493354,17.006959 C6.28568173,17.006959 6.05066464,16.7836002 6.05066464,16.5109416 L6.05066464,9.45602415 L11.1178883,12.6514631 C11.3858716,12.8214974 11.6932017,12.9060116 12.0005317,12.9060116 C12.3078618,12.9060116 12.6151918,12.8214974 12.8821117,12.6524692 L17.9503988,9.45602415 L17.9503988,16.5109416 C17.9503988,16.7836002 17.7143183,17.006959 17.4250665,17.006959 M6.57493354,6.993041 L17.4250665,6.993041 C17.7143183,6.993041 17.9503988,7.21639977 17.9503988,7.49006456 L17.9503988,8.29395489 L12.3153057,11.8485789 C12.1238891,11.9683072 11.8761109,11.9693133 11.6857577,11.8475727 L6.05066464,8.29395489 L6.05066464,7.49006456 C6.05066464,7.21639977 6.28568173,6.993041 6.57493354,6.993041 M17.4250665,6 L6.57493354,6 C5.70717812,6 5,6.66907018 5,7.49006456 L5,16.5109416 C5,17.3319359 5.70717812,18 6.57493354,18 L17.4250665,18 C18.2938853,18 19,17.3319359 19,16.5109416 L19,7.49006456 C19,6.66907018 18.2938853,6 17.4250665,6"
    })),
    /*#__PURE__*/
    React__default.createElement("use", {
      xlinkHref: "#share-by-email-a"
    }))
  );
};

TwitterEmail.propTypes = {
  fill: PropTypes.string
};
TwitterEmail.defaultProps = {
  fill: iconColorsMap.twitteremail
};
var _excluded$2P = ["fill"];

var TwitterLike = function TwitterLike(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2P);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      d: "M8.76402116,6.10996867 C7.31534392,6.10996867 6.04550265,7.58205478 6.04550265,9.25994056 C6.04550265,13.5086352 10.9439153,17.8427986 12,17.8900313 C13.0571429,17.8427986 17.9555556,13.5086352 17.9555556,9.25994056 C17.9555556,7.58205478 16.6846561,6.10996867 15.2359788,6.10996867 C13.4751323,6.10996867 12.4920635,8.28267331 12.4835979,8.30404049 C12.3227513,8.72013816 11.6772487,8.72013816 11.5174603,8.30404049 C11.5089947,8.28267331 10.5259259,6.10996867 8.76402116,6.10996867 L8.76402116,6.10996867 Z M12,19 L11.9904762,19 C10.1915344,18.9640132 5,13.9798377 5,9.25994056 C5,6.98939674 6.75873016,5 8.76402116,5 C10.3587302,5 11.431746,6.16957185 12,7.01976062 C12.568254,6.16957185 13.6412698,5 15.2359788,5 C17.2412698,5 19,6.98939674 19,9.25994056 C19,13.9798377 13.8095238,18.9640132 12.0095238,19 L12,19 Z"
    }))
  );
};

TwitterLike.propTypes = {
  fill: PropTypes.string
};
TwitterLike.defaultProps = {
  fill: iconColorsMap.twitterlike
};
var _excluded$2Q = ["fill"];

var TwitterVerified = function TwitterVerified(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2Q);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: fill
    }, props),
    /*#__PURE__*/
    React__default.createElement("path", {
      fillRule: "evenodd",
      d: "M15.76 10.426c.128-.177.24-.386.24-.594-.017-.193-.08-.418-.256-.563-.146-.176-.37-.24-.563-.24-.209 0-.45.064-.578.24l-3.871 3.857-1.334-1.35c-.176-.145-.353-.241-.578-.241-.225 0-.401.096-.594.24-.129.177-.241.37-.226.58 0 .208.065.433.241.578l1.912 1.927c.08.08.162.129.274.176a.702.702 0 00.32.065c.081 0 .21-.016.306-.065a.74.74 0 00.257-.176h.016c-.016 0-.016 0 0 0-.016 0-.016 0 0 0l4.418-4.434h.016zm3.838 3.502c-.273.466-.627.852-1.091 1.108a.231.231 0 01.031.097.104.104 0 000 .097.204.204 0 01.016.096.101.101 0 000 .096c-.016.852-.337 1.607-.867 2.153s-1.238.9-2.056.9c-.177 0-.353-.033-.515-.065-.16-.032-.352-.065-.498-.128-.256.513-.594.932-1.043 1.236a2.854 2.854 0 01-1.591.482 2.7 2.7 0 01-1.542-.482c-.45-.304-.85-.723-1.06-1.236a2.9 2.9 0 01-.497.128c-.193.032-.338.065-.531.065a2.868 2.868 0 01-2.056-.9 3.05 3.05 0 01-.835-2.153.101.101 0 010-.096v-.096a.104.104 0 010-.097.104.104 0 000-.097 3.207 3.207 0 01-1.06-1.108A2.98 2.98 0 014 12.37c-.016-.594.176-1.157.45-1.639.273-.482.707-.851 1.173-1.092l-.065-.257a1.372 1.372 0 01-.063-.273c-.017-.08-.017-.176-.033-.273a.792.792 0 010-.274 3.11 3.11 0 01.835-2.152 2.81 2.81 0 013.085-.706c.209-.498.61-.932 1.059-1.237A2.688 2.688 0 0111.984 4c.594 0 1.125.162 1.591.467.45.305.787.74 1.043 1.237.146-.065.338-.113.498-.144a2.784 2.784 0 012.57.85c.53.562.852 1.317.868 2.152-.016.097-.016.194-.016.274l-.047.273-.05.273a.804.804 0 01-.096.257c.514.24.9.61 1.205 1.092.306.482.434 1.045.45 1.639-.016.579-.144 1.108-.402 1.558z"
    }))
  );
};

TwitterVerified.propTypes = {
  fill: PropTypes.string
};
TwitterVerified.defaultProps = {
  fill: iconColorsMap.twitterverified
};
var _excluded$2R = ["name"];
var iconsMap = {
  'ad-equiv': AdEquiv,
  add: AddToGroup,
  'add-circle': AddCircle,
  'add-Paper': AddDocument,
  'add-to-group': AddToGroup$1,
  'arrow-back': ArrowBack,
  'arrow-down': ArrowDown,
  'arrow-drop-down': ArrowDropDown,
  'arrow-drop-up': ArrowDropUp,
  'arrow-forward': ArrowForward,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  attach: Attach,
  bell: Bell,
  blocked: Blocked,
  blog: Blog,
  bolt: Bolt,
  bookmark: Bookmark,
  business: Business,
  calendar: Calendar,
  campaign: Campaign,
  'chart-area': ChartArea,
  'chart-bars-border': ChartBarsBorder,
  'chart-bars-horz': ChartBarsHorz,
  'chart-bars-stacked': ChartBarsStacked,
  'chart-bars-vert': ChartBarsVert,
  'chart-bubble': ChartBubble,
  'chart-donut': ChartDonut,
  'chart-pie': ChartDonut$1,
  'chart-spark-and-bar': ChartSparkAndBar,
  'chart-sparkline': ChartSparkline,
  chat: Chat,
  check: Chat$1,
  'chevron-down': Chevron,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  clear: Chat$2,
  'times-circle': Chat$2,
  clock: Clock,
  close: Close,
  coffee: Close$1,
  'contact-list': ContactList,
  copy: Copy,
  dashbord: Dashboard,
  "delete": Delete,
  trash: Delete,
  dinner: Dinner,
  drinks: Drinks,
  download: Download,
  edit: Edit,
  'ellipsis-v': EllipsisV,
  enlarge: Enlarge,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  'folder-open': FolderOpen,
  'format-bold': FormatBold,
  'format-bullet-numbered': FormatBulletNumbered,
  'format-bullet-plain': FormatBulletPlain,
  'format-clear': FormatClear,
  'format-code': FormatCode,
  'format-italic': FormatItalic,
  'format-paragraph-center': FormatParagraphCenter,
  'format-paragraph-justify': FormatParagraphJustify,
  'format-paragraph-left': FormatParagraphLeft,
  'format-paragraph-right': FormatParagraphRight,
  'formatting-text-color': FormattingTextColor,
  'formatting-text': FormattingText,
  'formatting-underline': FormattingUnderline,
  globe: Globe,
  'gripper-corner': GripperCorner,
  gripper: Gripper,
  hamburger: Hamburger,
  hide: Hide,
  home: Home,
  hyperlink: Hyperlink,
  image: Image$1,
  inbox: Inbox,
  'info-2': Info2,
  info: Info,
  kebabs: Kebabs,
  'key-message': KeyMessage,
  key: Key,
  lightning: Lightning,
  'list-add': ListAdd,
  'list-alt': ListAlt,
  'list-verfied': ListVerfied,
  'list-view-active': ListViewActive,
  location: Location,
  lock: Lock,
  lunch: Lunch,
  magazine: Magazine,
  'mail-archive': MailArchive,
  'mail-bulk': MailBulk,
  'mail-draft': MailDraft,
  'mail-personal': MailPersonal,
  mail: Mail,
  'mark-as-unread': MarkAsUnread,
  meatballs: Meatballs,
  'media-list': MediaList,
  'mention-group': MentionGroup,
  'message-bubble': MessageBubble,
  mouse: Mouse,
  'move-to-inbox': MoveToInbox,
  move: Move,
  'new-tab': NewTab,
  news: News,
  note: Note,
  numbers: Numbers,
  paper: Paper,
  phone: Phone,
  pin: Pin,
  'pitch-stage': PitchStage,
  play: Play,
  refresh: Refresh,
  'reply-all': ReplyAll,
  reply: Reply,
  report: Report,
  restore: Restore,
  search: Search,
  send: Send,
  'sentiment-negative': SentimentNegative,
  'sentiment-positive': SentimentPositive,
  'sentiment-very-negative': SentimentVeryNegative,
  'sentiment-very-positive': SentimentVeryPositive,
  sentiment: Sentiment,
  'settings-gear': SettingsGear,
  'share-2': Share2,
  'share-with': ShareWith,
  shared: Shared,
  smartphone: Smartphone,
  'sort-asc': SortAsc,
  'sort-desc': SortDesc,
  'spike-alert': SpikeAlert,
  'star-empty': StarEmpty,
  'star-filled': StarFilled,
  station: Station,
  'sync-disabled': SyncDisabled,
  'sync-error': SyncError,
  sync: Sync,
  tag: Tag,
  'thumbs-up': ThumbsUp,
  'timer-off': TimerOff,
  timer: Timer,
  tv: Tv,
  upload: Upload,
  'user-relationship': UserRelationship,
  user: User,
  'user-empty': UserEmpty,
  'view-grid': ViewGrid,
  'view-stream': ViewStream,
  'view-table': ViewTable,
  'view-vertical-split': ViewVerticalSplit,
  view: View,
  warning: Warning,
  web: Web,
  work: Work,
  facebook: Facebook,
  instagram: Instagram,
  linkedin: LinkedIn,
  reddit: Reddit,
  twitch: Twitch,
  twitter: Twitter,
  youtube: YouTube,
  exchange: Exchange,
  google: Google,
  googleplus: GooglePlus,
  outlook: Outlook,
  slack: Slack,
  pinterest: Pinterest,
  retweet: Retweet,
  'twitter-comment': TwitterComment,
  'twitter-email': TwitterEmail,
  'twitter-like': TwitterLike,
  'twitter-verified': TwitterVerified
};

var Icon = function Icon(_ref) {
  var name = _ref.name,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2R);

  return iconsMap[name] ?
  /*#__PURE__*/
  React__default.createElement(iconsMap[name], passedProps) : null;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired
};
var _excluded$2S = ["borderless", "className", "children", "onCancel", "compact", "variant", "iconProps"];
var variants$1 = ['info', 'danger', 'warning', 'success'];

var Callout = function Callout(_ref) {
  var _classNames;

  var _ref$borderless = _ref.borderless,
      borderless = _ref$borderless === void 0 ? false : _ref$borderless,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? null : _ref$onCancel,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'info' : _ref$variant,
      _ref$iconProps = _ref.iconProps,
      iconProps = _ref$iconProps === void 0 ? {} : _ref$iconProps,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$2S);

  var baseClass = styles$5.Callout;
  var isValidVariant = includes(variants$1, variant) && styles$5[variant];
  var mainClass = classNames(baseClass, className, (_classNames = {}, _classNames[styles$5[variant]] = isValidVariant, _classNames[styles$5.borderless] = borderless, _classNames[styles$5.compact] = compact, _classNames[styles$5.cancelable] = onCancel !== null, _classNames));
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      className: mainClass
    }, props), children, onCancel && isFunction(onCancel) &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$5.cancel
    },
    /*#__PURE__*/
    React__default.createElement("button", {
      type: "button",
      className: styles$5.cancelButton
    },
    /*#__PURE__*/
    React__default.createElement(Icon, Object.assign({
      name: "close",
      className: styles$5.cancelIcon,
      compact: true,
      onClick: onCancel,
      size: "small"
    }, iconProps)))))
  );
};

Callout.defaultProps = {
  borderless: false,
  className: '',
  compact: false,
  iconProps: {},
  onCancel: undefined,
  variant: 'info'
};
Callout.propTypes = {
  borderless: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  iconProps: PropTypes.object,
  onCancel: PropTypes.func,
  compact: PropTypes.bool,
  variant: PropTypes.oneOf(variants$1)
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};
var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
var TransitionGroupContext = React__default.createContext(null);
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose$1(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,


    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        props = _objectWithoutPropertiesLoose$1(_this$props, ["classNames"]);

    return (
      /*#__PURE__*/
      React__default.createElement(Transition, _extends$1({}, props, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }))
    );
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var styles$6 = {
  "entering": "rvr-entering__309",
  "exiting": "rvr-exiting__1hH",
  "exited": "rvr-exited__1Rh"
};
var _excluded$2T = ["children", "isOpen", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "timeout"];

var Collapse = function Collapse(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$onEntered = _ref.onEntered,
      onEntered = _ref$onEntered === void 0 ? function () {} : _ref$onEntered,
      _ref$onEntering = _ref.onEntering,
      onEntering = _ref$onEntering === void 0 ? function () {} : _ref$onEntering,
      _ref$onExit = _ref.onExit,
      onExit = _ref$onExit === void 0 ? function () {} : _ref$onExit,
      _ref$onExited = _ref.onExited,
      onExited = _ref$onExited === void 0 ? function () {} : _ref$onExited,
      _ref$onExiting = _ref.onExiting,
      onExiting = _ref$onExiting === void 0 ? function () {} : _ref$onExiting,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 200 : _ref$timeout,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2T);

  var _useState = React.useState(null),
      height = _useState[0],
      setHeight = _useState[1];

  var handleEntering = React.useCallback(function (node, isAppearing) {
    setHeight(node.scrollHeight);
    node.style.transitionDuration = timeout + "ms";
    onEntering(node, isAppearing);
  }, [onEntering, setHeight, timeout]);
  var handleEntered = React.useCallback(function (node, isAppearing) {
    setHeight(null);
    onEntered(node, isAppearing);
  }, [onEntered, setHeight]);
  var handleExit = React.useCallback(function (node) {
    setHeight(node.scrollHeight);
    onExit(node);
  }, [onExit, setHeight]);
  var handleExiting = React.useCallback(function (node) {
    setHeight(0);
    node.style.transitionDuration = timeout + "ms";
    onExiting(node);
  }, [onExiting, setHeight, timeout]);
  var handleExited = React.useCallback(function (node) {
    setHeight(null);
    onExited(node);
  }, [onExited, setHeight]);
  return (
    /*#__PURE__*/
    React__default.createElement(Transition, Object.assign({}, passedProps, {
      "in": isOpen,
      timeout: timeout,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting,
      onExited: handleExited
    }), function (transitionState) {
      var styleHeight = isNull(height) ? {} : {
        height: height
      };
      return (
        /*#__PURE__*/
        React__default.createElement("div", {
          style: styleHeight,
          className: styles$6[transitionState]
        }, children)
      );
    })
  );
};

var Addon$2 = function Addon(props) {
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props))
  );
};

Addon$2.displayName = 'PillAddon';
var styles$7 = {
  "Pill": "rvr-Pill__2NF",
  "checked": "rvr-checked__2ss",
  "content": "rvr-content__34i",
  "actionInline": "rvr-actionInline__2se"
};
var _excluded$2U = ["children", "checked", "className", "onClick"];
var defaultProps = {
  checked: false,
  className: '',
  onClick: null
};

var Pill = function Pill(_ref) {
  var _classNames;

  var initChildren = _ref.children,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? defaultProps.checked : _ref$checked,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? defaultProps.onClick : _ref$onClick,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2U);

  var children = initChildren;
  children = React__default.Children.map(initChildren, function (child) {
    var _c$type;

    var c = child;
    return (c === null || c === void 0 ? void 0 : (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName) === Addon$2.displayName ?
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$7.actionInline
    },
    /*#__PURE__*/
    React__default.cloneElement(child, {
      checked: checked
    })) : child &&
    /*#__PURE__*/
    React__default.createElement("span", {
      className: styles$7.content
    }, child);
  });
  var clickableProps = onClick ? {
    role: 'button',
    tabIndex: 0,
    onClick: onClick
  } : {};
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, clickableProps, {
      className: classNames(styles$7.Pill, className, (_classNames = {}, _classNames[styles$7.checked] = checked, _classNames))
    }), children)
  );
};

Pill.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};
Pill.defaultProps = defaultProps;
Pill.Addon = Addon$2;
var _excluded$2V = ["children", "checked", "onDelete"];

var DeletablePill = function DeletablePill(_ref) {
  var children = _ref.children,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      onDelete = _ref.onDelete,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2V);

  return (
    /*#__PURE__*/
    React__default.createElement(Pill, Object.assign({
      checked: checked
    }, passedProps), children, checked &&
    /*#__PURE__*/
    React__default.createElement(Pill.Addon, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onDelete(e);
      },
      role: "button",
      tabIndex: 0
    },
    /*#__PURE__*/
    React__default.createElement(Icon, {
      name: "clear",
      style: {
        display: 'block'
      }
    })))
  );
};

var styles$8 = {
  "Dropdown": "rvr-Dropdown__MFj"
};
var isOpenContext =
/*#__PURE__*/
React__default.createContext(false);
var styles$9 = {
  "Menu": "rvr-Menu__31t",
  "entering": "rvr-entering__28B",
  "entered": "rvr-entered__bR4",
  "exiting": "rvr-exiting__2Nn",
  "exited": "rvr-exited__2oT",
  "topLeft": "rvr-topLeft__2uw",
  "topRight": "rvr-topRight__1BX",
  "bottomRight": "rvr-bottomRight__2EZ",
  "bottomLeft": "rvr-bottomLeft__34K"
};
var styles$a = {
  "Item": "rvr-Item__Y7A",
  "button": "rvr-button__3Ay",
  "disabled": "rvr-disabled__-64",
  "content": "rvr-content__2Hu"
};
var _excluded$2W = ["className", "forwardedRef"];

var hasHref$1 = function hasHref(props) {
  return 'href' in props && props.href !== undefined;
};

var Item = function Item(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      forwardedRef = _ref.forwardedRef,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2W);

  if (hasHref$1(passedProps) || passedProps.onClick) {
    var _classNames;

    return (
      /*#__PURE__*/
      React__default.createElement(Button.WithRef, Object.assign({
        className: classNames(styles$a.Item, styles$a.button, className, (_classNames = {}, _classNames[styles$a.disabled] = passedProps.disabled, _classNames)),
        level: "text",
        ref: forwardedRef,
        size: "md"
      }, passedProps))
    );
  }

  return (
    /*#__PURE__*/
    React__default.createElement(Button.WithRef, Object.assign({
      className: classNames(styles$a.Item, styles$a.content, className),
      level: "text",
      ref: forwardedRef,
      size: "md",
      tag: "div"
    }, passedProps))
  );
};

var ItemMoon =
/*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(Item, Object.assign({}, props, {
      forwardedRef: ref
    }))
  );
});
var _excluded$2X = ["className", "isOpen", "position"];

var Menu = function Menu(_ref) {
  var className = _ref.className,
      _ref$isOpen = _ref.isOpen,
      customIsOpen = _ref$isOpen === void 0 ? undefined : _ref$isOpen,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2X);

  return (
    /*#__PURE__*/
    React__default.createElement(isOpenContext.Consumer, null, function (isOpen) {
      return (
        /*#__PURE__*/
        React__default.createElement(Transition, {
          "in": customIsOpen === undefined ? isOpen : customIsOpen,
          timeout: 200,
          unmountOnExit: true
        }, function (transitionState) {
          return (
            /*#__PURE__*/
            React__default.createElement("div", Object.assign({}, passedProps, {
              className: classNames(styles$9.Menu, className, styles$9[position], styles$9[transitionState])
            }))
          );
        })
      );
    })
  );
};

Menu.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  position: PropTypes.oneOf(['topLeft', 'topRight', 'bottomRight', 'bottomLeft'])
};
Menu.defaultProps = {
  className: '',
  isOpen: undefined,
  position: 'bottomRight'
};
Menu.Item = ItemMoon;
var _excluded$2Y = ["children", "className", "disabled", "isOpen", "onToggle"];

var Dropdown = function Dropdown(_ref) {
  var _classNames;

  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2Y);

  var dropdown =
  /*#__PURE__*/
  React__default.createRef();
  var handleDocumentClick = React__default.useCallback(function (event) {
    var dropdownEl = dropdown === null || dropdown === void 0 ? void 0 : dropdown.current;

    if (!dropdownEl || dropdownEl.contains(event.target) && dropdownEl !== event.target) {
      return;
    }

    onToggle(event);
  }, [dropdown, onToggle]);
  var handleKeyUp = React__default.useCallback(function (event) {
    if (event.key === 'Escape') {
      onToggle(event);
    }
  }, [onToggle]);
  React.useEffect(function () {
    if (isOpen && !disabled) {
      document.addEventListener('click', handleDocumentClick, true);
      document.addEventListener('keyup', handleKeyUp);
    }

    if (!isOpen || disabled) {
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('keyup', handleKeyUp);
    }

    return function () {
      document.removeEventListener('click', handleDocumentClick, true);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [disabled, handleDocumentClick, handleKeyUp, isOpen, onToggle]);
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, {
      className: classNames(styles$8.Dropdown, className, (_classNames = {}, _classNames[styles$8.isOpen] = isOpen, _classNames)),
      ref: dropdown
    }),
    /*#__PURE__*/
    React__default.createElement(isOpenContext.Provider, {
      value: isOpen && !disabled
    }, children))
  );
};

Dropdown.Menu = Menu;
var styles$b = {
  "EasyDropdown": "rvr-EasyDropdown__20R",
  "group": "rvr-group__1YJ",
  "single": "rvr-single__2h7"
};
var _excluded$2Z = ["children", "className", "defaultIsOpen", "disabled", "isOpen", "menuItems", "menuProps", "onToggle", "toggleProps"],
    _excluded2 = ["children", "closeOnClick", "label"];

var EasyDropdown = function EasyDropdown(_ref) {
  var _ref$children = _ref.children,
      initChildren = _ref$children === void 0 ? undefined : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$defaultIsOpen = _ref.defaultIsOpen,
      defaultIsOpen = _ref$defaultIsOpen === void 0 ? undefined : _ref$defaultIsOpen,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isOpen = _ref.isOpen,
      controlledIsOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$menuItems = _ref.menuItems,
      menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems,
      _ref$menuProps = _ref.menuProps,
      menuProps = _ref$menuProps === void 0 ? {
    position: 'bottomRight'
  } : _ref$menuProps,
      _ref$onToggle = _ref.onToggle,
      parentOnToggle = _ref$onToggle === void 0 ? function () {} : _ref$onToggle,
      _ref$toggleProps = _ref.toggleProps,
      toggleProps = _ref$toggleProps === void 0 ? {
    className: ''
  } : _ref$toggleProps,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$2Z);

  var _useState = React.useState(defaultIsOpen),
      uncontrolledIsOpen = _useState[0],
      setUncontrolledIsOpen = _useState[1];

  var isControlled = defaultIsOpen === undefined;
  var isOpen = isControlled ? controlledIsOpen : uncontrolledIsOpen;
  var menuItemGroups = React.useMemo(function () {
    return menuItems.reduce(function (result, item) {
      var groupId = item.group;

      if (!groupId) {
        groupId = "_ungrouped-" + item.label;
      }

      result[groupId] = result[groupId] || [];
      result[groupId].push(item);
      return result;
    }, {});
  }, [menuItems]);
  var onToggle = React.useCallback(function (event) {
    var nextIsOpen;

    if (!isControlled) {
      setUncontrolledIsOpen(!uncontrolledIsOpen);
      nextIsOpen = !uncontrolledIsOpen;
    }

    if (parentOnToggle) parentOnToggle(event, nextIsOpen);
  }, [isControlled, parentOnToggle, uncontrolledIsOpen]);
  var children = React.useMemo(function () {
    var childrenArray = React__default.Children.toArray(initChildren);
    var hasStringChildren = childrenArray.reduce(function (result, child) {
      return result || typeof child === 'string';
    }, false);
    return hasStringChildren ?
    /*#__PURE__*/
    React__default.createElement(Button, Object.assign({}, toggleProps, {
      "data-is-open": isOpen,
      onClick: onToggle
    }), initChildren) : React__default.Children.map(initChildren, function (c) {
      var _child$props;

      var child = c;
      return (
        /*#__PURE__*/
        React__default.cloneElement(child, _extends({}, toggleProps, {
          className: classNames(child === null || child === void 0 ? void 0 : (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.className, toggleProps.className),
          'data-is-open': isOpen,
          onClick: function onClick(event) {
            var _child$props2;

            onToggle(event);

            if (child !== null && child !== void 0 && (_child$props2 = child.props) !== null && _child$props2 !== void 0 && _child$props2.onClick) {
              child.props.onClick(event);
            }
          }
        }))
      );
    });
  }, [initChildren, isOpen, onToggle, toggleProps]);
  return (
    /*#__PURE__*/
    React__default.createElement(Dropdown, Object.assign({}, passedProps, {
      className: classNames(className, styles$b.EasyDropdown),
      disabled: disabled,
      isOpen: isOpen,
      onToggle: onToggle
    }), children, !!menuItems.length &&
    /*#__PURE__*/
    React__default.createElement(Dropdown.Menu, Object.assign({}, menuProps, {
      position: menuProps.position || 'bottomRight'
    }), Object.keys(menuItemGroups).map(function (group) {
      var _classNames;

      return (
        /*#__PURE__*/
        React__default.createElement("div", {
          className: classNames((_classNames = {}, _classNames[styles$b.group] = group.indexOf('_ungrouped-') !== 0, _classNames[styles$b.single] = group.indexOf('_ungrouped-') === 0, _classNames)),
          key: group
        }, menuItemGroups[group].map(function (_ref2) {
          var itemChildren = _ref2.children,
              _ref2$closeOnClick = _ref2.closeOnClick,
              closeOnClick = _ref2$closeOnClick === void 0 ? true : _ref2$closeOnClick,
              label = _ref2.label,
              itemProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);

          return (
            /*#__PURE__*/
            React__default.createElement(Dropdown.Menu.Item, Object.assign({}, itemProps, {
              key: label,
              onClick: function onClick(event) {
                if (!isControlled && closeOnClick) {
                  setUncontrolledIsOpen(false);
                }

                if (itemProps.onClick) {
                  itemProps.onClick(event);
                }
              },
              ref: itemProps.forwardedRef
            }), itemChildren || label)
          );
        }))
      );
    })))
  );
};

EasyDropdown.defaultProps = {
  children: undefined,
  className: '',
  defaultIsOpen: undefined,
  disabled: false,
  isOpen: undefined,
  menuItems: [],
  menuProps: {
    position: 'bottomRight'
  },
  onToggle: function onToggle() {},
  toggleProps: {
    className: ''
  }
};
var styles$c = {
  "Media": "rvr-Media__24I",
  "Body": "rvr-Body__2VN",
  "Item": "rvr-Item__RGa"
};
var _excluded$2_ = ["className"];

var MediaGenerator = function MediaGenerator(name, cssClass) {
  var MediaComponent = function MediaComponent(props) {
    var _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className,
        rest = _objectWithoutPropertiesLoose(props, _excluded$2_);

    return (
      /*#__PURE__*/
      React__default.createElement("div", Object.assign({}, rest, {
        className: classNames(cssClass, className)
      }))
    );
  };

  MediaComponent.propTypes = {
    className: PropTypes.string
  };
  MediaComponent.defaultProps = {
    className: ''
  };
  MediaComponent.displayName = name;
  return MediaComponent;
};

var Media = MediaGenerator('Media', styles$c.Media);
Media.Body = MediaGenerator('Media.Body', styles$c.Body);
Media.Item = MediaGenerator('Media.Item', styles$c.Item);
var styles$d = {
  "dropdownDeleteIcon": "rvr-dropdownDeleteIcon__29a"
};
var _excluded$2$ = ["actions", "children", "onDelete"];

var EasyPillDropdown = function EasyPillDropdown(_ref) {
  var actions = _ref.actions,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? function () {} : _ref$onDelete;

  if (!(actions !== null && actions !== void 0 && actions.length)) {
    return null;
  }

  var menuItems = [].concat(actions);

  if (onDelete) {
    menuItems.push({
      group: 'deletePill',
      label: 'Delete',
      children:
      /*#__PURE__*/
      React__default.createElement(Media, null,
      /*#__PURE__*/
      React__default.createElement(Media.Item, {
        className: styles$d.dropdownDeleteIcon
      },
      /*#__PURE__*/
      React__default.createElement(Icon, {
        height: 16,
        name: "trash",
        style: {
          display: 'block'
        },
        width: 16
      })),
      /*#__PURE__*/
      React__default.createElement(Media.Body, null, "Delete")),
      onClick: onDelete
    });
  }

  return (
    /*#__PURE__*/
    React__default.createElement(EasyDropdown, {
      style: {
        display: 'block'
      },
      menuProps: {
        position: 'bottomLeft'
      },
      menuItems: menuItems,
      defaultIsOpen: false,
      disabled: false,
      isOpen: false,
      onToggle: function onToggle() {},
      toggleProps: {},
      className: ""
    },
    /*#__PURE__*/
    React__default.createElement("div", {
      role: "button",
      tabIndex: 0
    },
    /*#__PURE__*/
    React__default.createElement(Icon, {
      name: "ellipsis-v",
      style: {
        display: 'block'
      }
    })))
  );
};

var EasyPill = function EasyPill(_ref2) {
  var actions = _ref2.actions,
      children = _ref2.children,
      onDelete = _ref2.onDelete,
      passedProps = _objectWithoutPropertiesLoose(_ref2, _excluded$2$);

  return (
    /*#__PURE__*/
    React__default.createElement(Pill, Object.assign({}, passedProps), children, passedProps.checked && (actions !== null && actions !== void 0 && actions.length ?
    /*#__PURE__*/
    React__default.createElement(Pill.Addon, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    },
    /*#__PURE__*/
    React__default.createElement(EasyPillDropdown, {
      actions: actions,
      onDelete: onDelete
    })) : onDelete &&
    /*#__PURE__*/
    React__default.createElement(Pill.Addon, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onDelete(e);
      }
    },
    /*#__PURE__*/
    React__default.createElement(Icon, {
      style: {
        display: 'block'
      },
      name: "clear"
    }))))
  );
};

var styles$e = {
  "Header": "rvr-Header__2MY",
  "expandIcon": "rvr-expandIcon__2cF",
  "expanded": "rvr-expanded__1DV"
};
var _excluded$30 = ["children", "className", "expanded", "expandIcon"];

var Header = function Header(_ref) {
  var _classNames;

  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$expandIcon = _ref.expandIcon,
      expandIconProp = _ref$expandIcon === void 0 ? null : _ref$expandIcon,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$30);

  var expandIcon = expandIconProp &&
  /*#__PURE__*/
  React__default.cloneElement(expandIconProp, _extends({}, expandIconProp.props, {
    className: classNames(styles$e.expandIcon, (_classNames = {}, _classNames[styles$e.expanded] = expanded, _classNames))
  }));
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, {
      className: classNames(className, styles$e.Header)
    }), isFunction(children) ? children(expandIcon) :
    /*#__PURE__*/
    React__default.createElement(React.Fragment, null, children, expandIcon))
  );
};

Header.displayName = 'ExpansionPanel.Header';

var Body = function Body(props) {
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props))
  );
};

Body.displayName = 'ExpansionPanel.Body';
var _excluded$31 = ["children", "collapseProps", "defaultExpanded", "expanded", "onToggle"];

var ExpansionPanel = function ExpansionPanel(_ref) {
  var _header$type;

  var children = _ref.children,
      _ref$collapseProps = _ref.collapseProps,
      collapseProps = _ref$collapseProps === void 0 ? {} : _ref$collapseProps,
      _ref$defaultExpanded = _ref.defaultExpanded,
      defaultExpanded = _ref$defaultExpanded === void 0 ? null : _ref$defaultExpanded,
      _ref$expanded = _ref.expanded,
      expandedProp = _ref$expanded === void 0 ? false : _ref$expanded,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? undefined : _ref$onToggle,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$31);

  var _useState = React.useState(defaultExpanded),
      uncontrolledExpanded = _useState[0],
      setUncontrolledExpanded = _useState[1];

  var isControlled = !isBoolean(defaultExpanded);
  var expanded = isControlled ? expandedProp : uncontrolledExpanded;

  var _React$Children$toArr = React__default.Children.toArray(children),
      header = _React$Children$toArr[0],
      body = _React$Children$toArr.slice(1);

  if ((header === null || header === void 0 ? void 0 : (_header$type = header.type) === null || _header$type === void 0 ? void 0 : _header$type.displayName) !== Header.displayName) {
    throw new Error('The first child of an ExpansionPanel *must* be an ExpansionPanel.Header');
  }

  var handleToggle = function handleToggle(event) {
    if (!isControlled) {
      setUncontrolledExpanded(function (prev) {
        return !prev;
      });
    }

    if (onToggle) {
      onToggle(event, !expanded);
    }
  };

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps), header &&
    /*#__PURE__*/
    React__default.cloneElement(header, {
      expanded: expanded,
      onClick: handleToggle
    }),
    /*#__PURE__*/
    React__default.createElement(Collapse, Object.assign({
      isOpen: !!expanded
    }, collapseProps), body))
  );
};

ExpansionPanel.Header = Header;
ExpansionPanel.Body = Body;

var parseCssSize = function parseCssSize(_ref) {
  var size = _ref.size;

  if (typeof size === 'number') {
    return {
      size: size,
      unit: 'px'
    };
  }

  var parsedSize;

  try {
    parsedSize = parseInt(size, 10);

    if (isNaN(parsedSize)) {
      throw new Error("That's not a number");
    }
  } catch (e) {
    return {
      size: 0,
      unit: 'px'
    };
  }

  var unit = size.replace(parsedSize, '') || 'px';
  return {
    size: parsedSize,
    unit: unit
  };
};

var styles$f = {
  "gridColumns": "rvr-gridColumns__uYl"
};
var styles$g = {
  "Entry": "rvr-Entry__2Oe",
  "Clear": "rvr-Clear__1oK"
};
var _excluded$32 = ["children", "entryPercentWidth", "gutter"];

var Entry = function Entry(_ref) {
  var children = _ref.children,
      _ref$entryPercentWidt = _ref.entryPercentWidth,
      entryPercentWidth = _ref$entryPercentWidt === void 0 ? 100 : _ref$entryPercentWidt,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$32);

  var c = children;
  var childProps = c.props || {};
  var _childProps$clear = childProps.clear,
      clear = _childProps$clear === void 0 ? false : _childProps$clear,
      _childProps$colSpan = childProps.colSpan,
      colSpan = _childProps$colSpan === void 0 ? 1 : _childProps$colSpan,
      _childProps$offset = childProps.offset,
      offset = _childProps$offset === void 0 ? 0 : _childProps$offset;
  clear = !!clear && clear !== 'false';
  colSpan = parseInt(colSpan, 10) || 1;
  offset = parseInt(offset, 10) || 0;
  var entry =
  /*#__PURE__*/
  React__default.createElement("div", Object.assign({}, passedProps, {
    className: styles$g.Entry,
    style: {
      flexBasis: entryPercentWidth * colSpan + "%",
      marginInlineStart: entryPercentWidth * offset + "%",
      maxWidth: entryPercentWidth * colSpan + "%",
      padding: gutter
    }
  }),
  /*#__PURE__*/
  React__default.cloneElement(c, {
    clear: undefined,
    colSpan: undefined,
    offset: undefined
  }));

  if (clear) {
    return (
      /*#__PURE__*/
      React__default.createElement(React.Fragment, null,
      /*#__PURE__*/
      React__default.createElement("div", {
        className: styles$g.Clear
      }), entry)
    );
  }

  return entry;
};

Entry.propTypes = {
  children: PropTypes.node,
  entryPercentWidth: PropTypes.number,
  gutter: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Entry.defaultProps = {
  children: '',
  entryPercentWidth: 100,
  gutter: 0
};
var _excluded$33 = ["children", "className", "gutter", "columns"];

var Grid = function Grid(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      customClassName = _ref$className === void 0 ? '' : _ref$className,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 1 : _ref$columns,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$33);

  var parsedGutter = parseCssSize({
    size: gutter
  });
  var safeGutter = "" + parsedGutter.size / 2 + parsedGutter.unit;
  var inverseGutter = "" + -parsedGutter.size / 2 + parsedGutter.unit;

  if (parsedGutter.unit === '%') {
    var safeGutterSize = parsedGutter.size / 2 * (100 / (parsedGutter.size + 100));
    safeGutter = "" + safeGutterSize + parsedGutter.unit;
  }

  var safeRows = columns || 1;
  var entryPercentWidth = 100 / safeRows;
  var entries = React__default.Children.toArray(children) || [];
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, {
      className: classNames(styles$f.Grid, customClassName)
    }),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$f.gridColumns,
      style: {
        margin: inverseGutter
      }
    }, entries.map(function (child) {
      return (
        /*#__PURE__*/
        React__default.createElement(Entry, {
          entryPercentWidth: entryPercentWidth,
          gutter: safeGutter,
          key: "entry" + child.key
        },
        /*#__PURE__*/
        React__default.cloneElement(child))
      );
    })))
  );
};

var styles$h = {
  "Paper": "rvr-Paper__1cd",
  "flat": "rvr-flat__1tn",
  "squared": "rvr-squared__3ht"
};
var _excluded$34 = ["className", "flat", "squared"];

var Paper$1 = function Paper(_ref) {
  var _classNames;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$flat = _ref.flat,
      flat = _ref$flat === void 0 ? false : _ref$flat,
      _ref$squared = _ref.squared,
      squared = _ref$squared === void 0 ? false : _ref$squared,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$34);

  var classname = classNames(styles$h.Paper, className, (_classNames = {}, _classNames[styles$h.flat] = flat, _classNames[styles$h.squared] = squared, _classNames));
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, rest, {
      className: classname
    }))
  );
};

var Context$1 =
/*#__PURE__*/
React.createContext(undefined);
var _excluded$35 = ["children", "customBreakpoints"];
var defaultBreakpoints = [{
  name: 'xs',
  minWidth: 0
}, {
  name: 'sm',
  minWidth: 600
}, {
  name: 'md',
  minWidth: 900
}, {
  name: 'lg',
  minWidth: 1200
}, {
  name: 'xl',
  minWidth: 1800
}];

var getBreakpointsQuery = function getBreakpointsQuery(breakpoints) {
  return breakpoints.reduce(function (result, breakpoint, index) {
    var _extends2;

    var _breakpoint$minWidth = breakpoint.minWidth,
        minWidth = _breakpoint$minWidth === void 0 ? 0 : _breakpoint$minWidth,
        name = breakpoint.name;
    var nextBreakpoint = breakpoints[index + 1] || null;
    var maxWidth = nextBreakpoint ? nextBreakpoint.minWidth - 0.2 : null;
    var maxProp = maxWidth ? {
      maxWidth: maxWidth
    } : {};
    var minProp = minWidth ? {
      minWidth: minWidth
    } : {};
    return _extends({}, result, (_extends2 = {}, _extends2["container-" + name + "-up"] = _extends({}, minProp), _extends2["container-" + name + "-down"] = _extends({}, maxProp), _extends2["container-" + name + "-only"] = _extends({}, maxProp, minProp), _extends2));
  }, {});
};

var Container = function Container(_ref) {
  var children = _ref.children,
      _ref$customBreakpoint = _ref.customBreakpoints,
      customBreakpoints = _ref$customBreakpoint === void 0 ? defaultBreakpoints : _ref$customBreakpoint,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$35);

  var query;

  if (customBreakpoints) {
    query = getBreakpointsQuery(customBreakpoints);
  } else {
    query = getBreakpointsQuery(defaultBreakpoints);
  }

  return (
    /*#__PURE__*/
    React__default.createElement(reactContainerQuery.ContainerQuery, {
      query: query
    }, function (params, ref) {
      var responsiveValue = Object.keys(params).reduce(function (result, paramKey) {
        if (params[paramKey]) {
          result.push(paramKey);
        }

        return result;
      }, []);
      return (
        /*#__PURE__*/
        React__default.createElement("div", Object.assign({}, passedProps, {
          ref: ref
        }),
        /*#__PURE__*/
        React__default.createElement(Context$1.Provider, {
          value: responsiveValue
        }, children))
      );
    })
  );
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  customBreakpoints: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    minWidth: PropTypes.number.isRequired
  }).isRequired)
};
Container.defaultProps = {
  customBreakpoints: defaultBreakpoints
};
var _excluded$36 = ["children"];

var Element$1 = function Element(_ref) {
  var children = _ref.children,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$36);

  return (
    /*#__PURE__*/
    React__default.createElement(Context$1.Consumer, null, function (context) {
      return React__default.Children.map(children, function (child) {
        return (
          /*#__PURE__*/
          React__default.cloneElement(child, _extends({}, passedProps, {
            responsiveContext: context
          }))
        );
      });
    })
  );
};

var _excluded$37 = ["breakpoints", "children", "columns", "gutter"];

var Grid$1 = function Grid$1(_ref) {
  var _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? {
    'container-xs-up': {
      columns: 1,
      gutter: 0
    }
  } : _ref$breakpoints,
      children = _ref.children,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 1 : _ref$columns,
      _ref$gutter = _ref.gutter,
      gutter = _ref$gutter === void 0 ? 0 : _ref$gutter,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$37);

  var responsiveProps = {
    columns: columns,
    gutter: gutter
  };
  var responsiveChildren = children;
  return (
    /*#__PURE__*/
    React__default.createElement(Context$1.Consumer, null, function (context) {
      if (context && context.length) {
        responsiveProps = context.reduce(function (result, query) {
          return _extends({}, result, breakpoints[query]);
        }, responsiveProps);
        responsiveChildren = React__default.Children.map(children, function (origChild) {
          var child = origChild;
          var childProps = child && child.props || {};
          var _childProps$clear = childProps.clear,
              clear = _childProps$clear === void 0 ? false : _childProps$clear,
              _childProps$colSpan = childProps.colSpan,
              colSpan = _childProps$colSpan === void 0 ? 1 : _childProps$colSpan,
              _childProps$offset = childProps.offset,
              offset = _childProps$offset === void 0 ? 0 : _childProps$offset;
          var childBreakpoints = childProps.breakpoints;
          childBreakpoints = childBreakpoints || {};
          var responsiveChildProps = context.reduce(function (result, query) {
            return _extends({}, result, childBreakpoints[query]);
          }, {
            clear: clear,
            colSpan: colSpan,
            offset: offset
          });
          return (
            /*#__PURE__*/
            React__default.cloneElement(child, _extends({}, responsiveChildProps))
          );
        });
      }

      return (
        /*#__PURE__*/
        React__default.createElement(Grid, Object.assign({}, passedProps, responsiveProps), responsiveChildren)
      );
    })
  );
};

var _excluded$38 = ["children", "breakpoints"];

var Hidden = function Hidden(_ref) {
  var children = _ref.children,
      _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$38);

  var getIsHidden = React.useCallback(function (responsiveContext) {
    return !!intersection(breakpoints, responsiveContext != null ? responsiveContext : []).length;
  }, [breakpoints]);
  return (
    /*#__PURE__*/
    React__default.createElement(Context$1.Consumer, null, function (responsiveContext) {
      var hidden = getIsHidden(responsiveContext);
      return React__default.Children.map(children, function (child) {
        if (!child || hidden) {
          return null;
        }

        if (typeof child === 'string') {
          return (
            /*#__PURE__*/
            React__default.createElement("span", null, child)
          );
        }

        return (
          /*#__PURE__*/
          React__default.cloneElement(child, _extends({}, passedProps))
        );
      });
    })
  );
};

var _excluded$39 = ["children", "breakpoints"];

var Visible = function Visible(_ref) {
  var children = _ref.children,
      _ref$breakpoints = _ref.breakpoints,
      breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$39);

  var getIsVisible = React.useCallback(function (responsiveContext) {
    return !!intersection(breakpoints, responsiveContext).length;
  }, [breakpoints]);
  return (
    /*#__PURE__*/
    React__default.createElement(Context$1.Consumer, null, function (responsiveContext) {
      var visible = getIsVisible(responsiveContext);
      return React__default.Children.map(children, function (child) {
        if (!child || !visible) {
          return null;
        }

        if (typeof child === 'string') {
          return (
            /*#__PURE__*/
            React__default.createElement("span", null, child)
          );
        }

        return (
          /*#__PURE__*/
          React__default.cloneElement(child, _extends({}, passedProps))
        );
      });
    })
  );
};

var Responsive = {
  Container: Container,
  Context: Context$1,
  Element: Element$1,
  Grid: Grid$1,
  Hidden: Hidden,
  Visible: Visible
};
var styles$i = {
  "SideTray": "rvr-SideTray__3Rs",
  "container": "rvr-container__F0z",
  "backdrop": "rvr-backdrop__1YE",
  "body": "rvr-body__3NC",
  "header": "rvr-header__3XU",
  "footer": "rvr-footer__1eo"
};
var _excluded$3a = ["className"],
    _excluded2$1 = ["className"],
    _excluded3 = ["className"],
    _excluded4 = ["children", "className", "direction", "height", "onClose", "style", "visible", "width"];

var Header$1 = function Header(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3a);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$i.header, className)
    }))
  );
};

var Footer = function Footer(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$i.footer, className)
    }))
  );
};

var Body$1 = function Body(_ref3) {
  var _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$i.body, className)
    }))
  );
};

var SideTray = function SideTray(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === void 0 ? 'r' : _ref4$direction,
      _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? '100vh' : _ref4$height,
      onClose = _ref4.onClose,
      _ref4$style = _ref4.style,
      style = _ref4$style === void 0 ? {} : _ref4$style,
      _ref4$visible = _ref4.visible,
      visible = _ref4$visible === void 0 ? false : _ref4$visible,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? '400px' : _ref4$width,
      passedProps = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  React.useEffect(function () {
    var handleEscape = function handleEscape(e) {
      if (visible && e.keyCode === 27) {
        onClose(e);
      }
    };

    if (visible) {
      window.addEventListener('keyup', handleEscape);
    }

    if (!visible) {
      window.removeEventListener('keyup', handleEscape);
    }

    return function () {
      if (visible) window.removeEventListener('keyup', handleEscape);
    };
  }, [visible, onClose]);
  var clickOffBackdrop = visible ?
  /*#__PURE__*/
  React__default.createElement("button", {
    type: "button",
    className: styles$i.backdrop,
    onClick: onClose
  }) : null;
  var parsedHeight = parseCssSize({
    size: height
  });
  var parsedWidth = parseCssSize({
    size: width
  });
  var hideTransformStyle;
  var sideTrayStyles = {
    bottom: 0,
    height: "" + parsedHeight.size + parsedHeight.unit,
    left: 0,
    right: 0,
    top: 0,
    width: "" + parsedWidth.size + parsedWidth.unit
  };

  switch (direction) {
    case 't':
      hideTransformStyle = "translate3d(0, " + -parsedHeight.size + parsedHeight.unit + ", 0)";
      sideTrayStyles.bottom = 'auto';
      break;

    case 'b':
      hideTransformStyle = "translate3d(0, " + parsedHeight.size + parsedHeight.unit + ", 0)";
      sideTrayStyles.top = 'auto';
      break;

    case 'l':
      hideTransformStyle = "translate3d(" + -parsedWidth.size + parsedWidth.unit + ", 0, 0)";
      sideTrayStyles.right = 'auto';
      break;

    default:
    case 'r':
      hideTransformStyle = "translate3d(" + parsedWidth.size + parsedWidth.unit + ", 0, 0)";
      sideTrayStyles.left = 'auto';
      break;
  }

  return (
    /*#__PURE__*/
    React__default.createElement(React__default.Fragment, null,
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, passedProps, {
      style: _extends({}, sideTrayStyles, !visible ? {
        transform: hideTransformStyle
      } : {}, style),
      className: classNames(styles$i.SideTray, className)
    }),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$i.container
    }, children)), clickOffBackdrop)
  );
};

SideTray.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['t', 'r', 'b', 'l']),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  style: PropTypes.object,
  visible: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
SideTray.Header = Header$1;
SideTray.Footer = Footer;
SideTray.Body = Body$1;
var styles$j = {
  "Item": "rvr-Item__pvw",
  "active": "rvr-active__8MI"
};
var _excluded$3b = ["className", "active", "children"];

var Item$1 = function Item(_ref) {
  var _classNames;

  var customClassName = _ref.className,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3b);

  var isChildActive = function isChildActive(child) {
    if (
    /*#__PURE__*/
    React__default.isValidElement(child)) {
      var _child$props, _child$props$classNam;

      return ((_child$props = child.props) === null || _child$props === void 0 ? void 0 : (_child$props$classNam = _child$props.className) === null || _child$props$classNam === void 0 ? void 0 : _child$props$classNam.indexOf('active')) >= 0;
    }

    return false;
  };

  var className = classNames(styles$j.Item, customClassName, (_classNames = {}, _classNames[styles$j.active] = active || isChildActive(children), _classNames));
  return (
    /*#__PURE__*/
    React__default.createElement("li", Object.assign({
      className: className
    }, props), children)
  );
};

var styles$k = {
  "TabMenu": "rvr-TabMenu__36A",
  "leftAlign": "rvr-leftAlign__SFB",
  "centerAlign": "rvr-centerAlign__2jF",
  "rightAlign": "rvr-rightAlign__3Nu",
  "itemPadding": "rvr-itemPadding__1Hj",
  "activeButton": "rvr-activeButton__2UI",
  "xsTextSize": "rvr-xsTextSize__2j8",
  "smTextSize": "rvr-smTextSize__VkE",
  "mdTextSize": "rvr-mdTextSize__3Bb",
  "lgTextSize": "rvr-lgTextSize__2GP"
};
var _excluded$3c = ["align", "className"],
    _excluded2$2 = ["tabs", "activeTab", "size"];

var TabMenu = function TabMenu(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3c);

  var tabMenuClass = classNames(styles$k.TabMenu, className, styles$k[align + "Align"]);
  return (
    /*#__PURE__*/
    React__default.createElement("ul", Object.assign({
      className: tabMenuClass
    }, props))
  );
};

TabMenu.Item = Item$1;

var EasyTabMenu = function EasyTabMenu(_ref2) {
  var _ref2$tabs = _ref2.tabs,
      tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs,
      _ref2$activeTab = _ref2.activeTab,
      activeTab = _ref2$activeTab === void 0 ? '' : _ref2$activeTab,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'md' : _ref2$size,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);

  return (
    /*#__PURE__*/
    React__default.createElement(TabMenu, Object.assign({}, props), tabs.filter(function (tab) {
      return tab !== undefined;
    }).map(function (tab) {
      var _classNames;

      var inner = classNames(styles$k.itemPadding, styles$k[size + "TextSize"], (_classNames = {}, _classNames[styles$k.activeButton] = tab.key === activeTab, _classNames));
      return (
        /*#__PURE__*/
        React__default.createElement(Item$1, {
          key: tab.key,
          active: tab.key === activeTab
        },
        /*#__PURE__*/
        React__default.createElement("button", {
          type: "button",
          className: inner,
          onClick: tab.onClick
        }, tab.label))
      );
    }))
  );
};

var SimpleTabMenu = EasyTabMenu;
var styles$l = {
  "wrapper": "rvr-wrapper__1PA",
  "original": "rvr-original__1tr",
  "fade": "rvr-fade__3Se",
  "main-bottom": "rvr-main-bottom__2bg",
  "main-top": "rvr-main-top__2n8",
  "main-left": "rvr-main-left__1Fm",
  "main-right": "rvr-main-right__OF-",
  "fadeEnter": "rvr-fadeEnter__1nP",
  "fadeEnterActive": "rvr-fadeEnterActive__2kS",
  "fadeExit": "rvr-fadeExit__3ak",
  "fadeExitActive": "rvr-fadeExitActive__1pW",
  "Tooltip": "rvr-Tooltip__3JI",
  "secondary-left": "rvr-secondary-left__OOg",
  "secondary-right": "rvr-secondary-right__IxO",
  "secondary-top": "rvr-secondary-top__E9D",
  "secondary-bottom": "rvr-secondary-bottom__3QX",
  "arrow": "rvr-arrow__3EB",
  "tooltipInnerWrapper": "rvr-tooltipInnerWrapper__3Ht",
  "textContent": "rvr-textContent__18W",
  "textContentHasWidth": "rvr-textContentHasWidth__2SZ",
  "tooltipClose": "rvr-tooltipClose__2eG"
};
var _excluded$3d = ["children", "className", "closeButtonProps", "closeOnEscape", "content", "direction", "isOpen", "onClose", "showOnHover", "tooltipProps", "tooltipWidth"],
    _excluded2$3 = ["style", "className"],
    _excluded3$1 = ["onClose", "children"];
var transitionDuration = 300;

var Tooltip = function Tooltip(_ref) {
  var _classNames, _classNames2;

  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$closeButtonProps = _ref.closeButtonProps,
      closeButtonProps = _ref$closeButtonProps === void 0 ? {} : _ref$closeButtonProps,
      _ref$closeOnEscape = _ref.closeOnEscape,
      closeOnEscape = _ref$closeOnEscape === void 0 ? true : _ref$closeOnEscape,
      _ref$content = _ref.content,
      tooltipContent = _ref$content === void 0 ? null : _ref$content,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'top' : _ref$direction,
      _ref$isOpen = _ref.isOpen,
      controlledIsOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? null : _ref$onClose,
      _ref$showOnHover = _ref.showOnHover,
      showOnHover = _ref$showOnHover === void 0 ? false : _ref$showOnHover,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipOptsProp = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
      _ref$tooltipWidth = _ref.tooltipWidth,
      tooltipWidth = _ref$tooltipWidth === void 0 ? null : _ref$tooltipWidth,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3d);

  var _useState = React.useState(false),
      uncontrolledIsOpen = _useState[0],
      setUncontrolledIsOpen = _useState[1];

  var isControlled = !showOnHover;
  var isOpen = isControlled ? controlledIsOpen : uncontrolledIsOpen;

  var _useState2 = React.useState("tooltip-" + Date.now() * Math.floor(100 * Math.random())),
      tooltipId = _useState2[0];

  var tooltipRef = React.useRef(null);
  var tooltipWrapperRef = React.useRef(null);

  var _useState3 = React.useState(true),
      isTooltipWiderThanParent = _useState3[0],
      setIsTooltipWiderThanParent = _useState3[1];

  var handleSetHover = React.useCallback(function (value) {
    if (!isControlled) {
      setUncontrolledIsOpen(value);
    }
  }, [isControlled, setUncontrolledIsOpen]);
  React.useEffect(function () {
    var handleEscape = function handleEscape(e) {
      if (e.key === 'Escape') {
        if (!isControlled) {
          setUncontrolledIsOpen(false);
        }

        if (onClose) onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return function () {
      return document.removeEventListener('keydown', handleEscape);
    };
  }, [closeOnEscape, isControlled, onClose]);

  var tooltipStyle = tooltipOptsProp.style,
      tooltipClassName = tooltipOptsProp.className,
      tooltipOpts = _objectWithoutPropertiesLoose(tooltipOptsProp, _excluded2$3);

  var _useMemo = React.useMemo(function () {
    var parsedDirection = direction.split('-');
    var secondary = parsedDirection[1];

    if (['left', 'right'].indexOf(secondary) >= 0 && !isTooltipWiderThanParent) {
      secondary = '';
    }

    return [parsedDirection[0], secondary];
  }, [direction, isTooltipWiderThanParent]),
      mainDirection = _useMemo[0],
      secondaryDirection = _useMemo[1];

  var directionClassNames = classNames(styles$l["main-" + mainDirection], (_classNames = {}, _classNames[styles$l["secondary-" + secondaryDirection]] = secondaryDirection, _classNames));
  var tooltipClassNames = classNames(styles$l.Tooltip, tooltipClassName);
  var isText = typeof tooltipContent === 'string';
  var tooltipHasWidth = tooltipStyle && tooltipStyle.width || tooltipWidth;
  var tooltipWrapperProps = {
    style: {
      width: tooltipHasWidth
    },
    className: tooltipClassNames
  };
  React.useLayoutEffect(function () {
    if (isOpen && tooltipRef.current && tooltipWrapperRef.current) {
      setIsTooltipWiderThanParent(tooltipRef.current.offsetWidth > tooltipWrapperRef.current.offsetWidth);
    }
  }, [isOpen]);
  var TooltipContent = tooltipContent &&
  /*#__PURE__*/
  React__default.createElement("div", {
    style: {
      transitionDuration: transitionDuration / 1000 + "s"
    }
  },
  /*#__PURE__*/
  React__default.createElement("div", {
    className: styles$l.arrow
  }),
  /*#__PURE__*/
  React__default.createElement("div", Object.assign({
    id: tooltipId,
    "aria-hidden": !isOpen,
    ref: tooltipRef,
    role: "tooltip"
  }, tooltipWrapperProps),
  /*#__PURE__*/
  React__default.createElement("div", Object.assign({
    style: tooltipStyle,
    className: styles$l.tooltipInnerWrapper
  }, tooltipOpts), !!onClose &&
  /*#__PURE__*/
  React__default.createElement("button", Object.assign({
    type: "button",
    className: styles$l.tooltipClose,
    onClick: onClose,
    "aria-label": "Close"
  }, closeButtonProps),
  /*#__PURE__*/
  React__default.createElement(Icon, {
    name: "close"
  })), isText ?
  /*#__PURE__*/
  React__default.createElement("div", {
    className: classNames((_classNames2 = {}, _classNames2[styles$l.textContentHasWidth] = tooltipHasWidth, _classNames2[styles$l.textContent] = !tooltipHasWidth, _classNames2))
  }, tooltipContent) : tooltipContent)));

  var noop = function noop() {};

  var tooltipTriggerProps = {
    onClick: noop,
    onKeyPress: noop,
    role: 'button',
    tabIndex: 0
  };
  var tooltipTriggers = React__default.Children.map(children, function (child) {
    if (typeof child === 'string') {
      return (
        /*#__PURE__*/
        React__default.createElement("span", Object.assign({}, tooltipTriggerProps), child)
      );
    }

    var childEl =
    /*#__PURE__*/
    React__default.isValidElement(child) ? child : null;

    if (childEl) {
      return (
        /*#__PURE__*/
        React__default.cloneElement(childEl, _extends({}, tooltipTriggerProps, childEl === null || childEl === void 0 ? void 0 : childEl.props))
      );
    }

    return null;
  });
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      className: styles$l.wrapper,
      onBlur: function onBlur() {
        return handleSetHover(false);
      },
      onFocus: function onFocus() {
        return handleSetHover(true);
      },
      onMouseLeave: function onMouseLeave() {
        return handleSetHover(false);
      },
      onMouseEnter: function onMouseEnter() {
        return handleSetHover(true);
      },
      ref: tooltipWrapperRef
    }, rest),
    /*#__PURE__*/
    React__default.createElement("div", {
      "aria-describedby": tooltipId,
      className: classNames(className, styles$l.original)
    }, tooltipTriggers),
    /*#__PURE__*/
    React__default.createElement(CSSTransition, {
      className: classNames(styles$l.fade, directionClassNames),
      classNames: {
        enter: styles$l.fadeEnter,
        enterActive: styles$l.fadeEnterActive,
        exit: styles$l.fadeExit,
        exitActive: styles$l.fadeExitActive
      },
      "in": isOpen,
      timeout: transitionDuration,
      unmountOnExit: true
    }, TooltipContent))
  );
};

var EasyRichTooltip = function EasyRichTooltip(_ref2) {
  var _onClose = _ref2.onClose,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded3$1);

  var _useState4 = React.useState(false),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var open = function open() {
    return setOpen(true);
  };

  var close = function close() {
    return setOpen(false);
  };

  var toggle = function toggle() {
    return setOpen(function (prev) {
      return !prev;
    });
  };

  return (
    /*#__PURE__*/
    React__default.createElement(Tooltip, Object.assign({
      isOpen: isOpen,
      onClose: function onClose() {
        if (_onClose) {
          _onClose();
        }

        setOpen(false);
      }
    }, props), children({
      open: open,
      close: close,
      toggle: toggle
    }))
  );
};

var styles$m = {
  "Checkbox": "rvr-Checkbox__1pl",
  "svg": "rvr-svg__1l8",
  "input": "rvr-input__1X4",
  "outline": "rvr-outline__IU1",
  "inner": "rvr-inner__2kI",
  "check": "rvr-check__etO",
  "dash": "rvr-dash__18r",
  "checked": "rvr-checked__2jV",
  "indeterminate": "rvr-indeterminate__1ex",
  "disabled": "rvr-disabled__1Ie"
};
var _excluded$3e = ["title"];

var svg = function svg(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Checkbox' : _ref$title,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3e);

  return (
    /*#__PURE__*/
    React__default.createElement("svg", Object.assign({
      width: "18px",
      height: "18px",
      viewBox: "0 0 18 18",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, passedProps),
    /*#__PURE__*/
    React__default.createElement("title", null, title),
    /*#__PURE__*/
    React__default.createElement("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    },
    /*#__PURE__*/
    React__default.createElement("polygon", {
      className: styles$m.outline,
      fill: "#34404B",
      points: "0 0 18 0 18 18 0 18"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      className: styles$m.inner,
      fill: "#34404B",
      points: "16 16 16 2 2 2 2 16"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      className: styles$m.check,
      fill: "#34404B",
      points: "7 14 2 9 3.41 7.59 7 11.17 14.59 3.58 16 5"
    }),
    /*#__PURE__*/
    React__default.createElement("polygon", {
      className: styles$m.dash,
      fill: "#34404B",
      points: "14 10 4 10 4 8 14 8"
    })))
  );
};

var _excluded$3f = ["checked", "className", "fauxDisabled", "forwardedRef"];

var CheckboxWithRef = function CheckboxWithRef(_ref) {
  var _classNames;

  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$fauxDisabled = _ref.fauxDisabled,
      fauxDisabled = _ref$fauxDisabled === void 0 ? false : _ref$fauxDisabled,
      ref = _ref.forwardedRef,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3f);

  return (
    /*#__PURE__*/
    React__default.createElement("div", {
      className: classNames(styles$m.Checkbox, className, (_classNames = {}, _classNames[styles$m.checked] = checked, _classNames[styles$m.disabled] = fauxDisabled, _classNames))
    },
    /*#__PURE__*/
    React__default.createElement("input", Object.assign({
      checked: checked,
      className: styles$m.input,
      ref: ref || undefined,
      tabIndex: fauxDisabled ? -1 : undefined,
      type: "checkbox"
    }, passedProps)),
    /*#__PURE__*/
    React__default.createElement(svg, {
      "aria-hidden": true,
      className: styles$m.svg
    }))
  );
};

var Checkbox =
/*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(CheckboxWithRef, Object.assign({}, props, {
      forwardedRef: ref || undefined
    }))
  );
});
var inputStyles = {
  "Input": "rvr-Input__2nh",
  "focus": "rvr-focus__36c",
  "disabled": "rvr-disabled__2tf",
  "invalid": "rvr-invalid__2Dt"
};
var _excluded$3g = ["className", "fauxDisabled", "forwardedRef", "type"];

var Input = function Input(_ref) {
  var _classNames;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$fauxDisabled = _ref.fauxDisabled,
      fauxDisabled = _ref$fauxDisabled === void 0 ? false : _ref$fauxDisabled,
      ref = _ref.forwardedRef,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3g);

  if (type.toLowerCase() === 'checkbox') {
    return (
      /*#__PURE__*/
      React__default.createElement(Checkbox, Object.assign({
        className: classNames(className),
        ref: ref || undefined,
        fauxDisabled: fauxDisabled
      }, passedProps))
    );
  }

  return (
    /*#__PURE__*/
    React__default.createElement("input", Object.assign({
      className: classNames(inputStyles.Input, className, (_classNames = {}, _classNames[inputStyles.disabled] = fauxDisabled, _classNames)),
      ref: ref || undefined,
      tabIndex: fauxDisabled ? -1 : undefined,
      type: type
    }, passedProps))
  );
};

var Input$1 =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(Input, Object.assign({}, props, {
      forwardedRef: ref || undefined
    }))
  );
});
var styles$n = {
  "Toggle": "rvr-Toggle__2AI",
  "input": "rvr-input__2K-",
  "notch": "rvr-notch__2pE",
  "checked": "rvr-checked__3s4",
  "disabled": "rvr-disabled__1dN"
};
var _excluded$3h = ["checked", "fauxDisabled", "forwardedRef", "className"];

var ToggleWithRef = function ToggleWithRef(_ref) {
  var _classNames;

  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$fauxDisabled = _ref.fauxDisabled,
      fauxDisabled = _ref$fauxDisabled === void 0 ? false : _ref$fauxDisabled,
      ref = _ref.forwardedRef,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3h);

  var mainClass = classNames(styles$n.Toggle, className, (_classNames = {}, _classNames[styles$n.checked] = checked, _classNames[styles$n.disabled] = fauxDisabled, _classNames));
  return (
    /*#__PURE__*/
    React__default.createElement("div", {
      role: "checkbox",
      "aria-checked": checked,
      className: mainClass
    },
    /*#__PURE__*/
    React__default.createElement("input", Object.assign({
      type: "checkbox",
      "aria-hidden": true,
      tabIndex: fauxDisabled ? -1 : undefined,
      checked: checked,
      ref: ref || undefined
    }, passedProps, {
      className: styles$n.input
    })),
    /*#__PURE__*/
    React__default.createElement("span", {
      className: styles$n.notch
    }))
  );
};

var Toggle =
/*#__PURE__*/
React__default.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(ToggleWithRef, Object.assign({}, props, {
      forwardedRef: ref || undefined
    }))
  );
});
var _excluded$3i = ["formatTime", "locale"];

var nullSafeMatch = function nullSafeMatch(string, regExp) {
  var _match$, _match$index;

  var match = string.match(regExp);
  var content = (_match$ = match === null || match === void 0 ? void 0 : match[0]) != null ? _match$ : '';
  var index = (_match$index = match === null || match === void 0 ? void 0 : match.index) != null ? _match$index : 0;
  var endIndex = content.length + index;
  return {
    content: content,
    index: index,
    endIndex: endIndex
  };
};

var handleDispatchNativeInputChange = function handleDispatchNativeInputChange(element, nextValue) {
  var _Object$getOwnPropert;

  var nativeInputValueSetter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.set;

  if (nativeInputValueSetter) {
    nativeInputValueSetter.call(element, nextValue);
    var passedEvent = new Event('input', {
      bubbles: true
    });
    element.dispatchEvent(passedEvent);
  }
};

var getTimeZoneOffsetFromLocal = function getTimeZoneOffsetFromLocal(targetMinusUtc) {
  if (typeof targetMinusUtc !== 'number') {
    return 0;
  }

  var utcMinusLocal = new Date().getTimezoneOffset();
  return targetMinusUtc + utcMinusLocal;
};

var getEndOfDay = function getEndOfDay(date, options) {
  var _ref = options || {},
      timeZoneOffset = _ref.timeZoneOffset;

  var tzOffset = getTimeZoneOffsetFromLocal(timeZoneOffset);
  var endOfDay = new Date(date);
  endOfDay.setDate(endOfDay.getDate() + 1);
  endOfDay.setHours(0);
  endOfDay.setMinutes(0 - tzOffset);
  endOfDay.setSeconds(0);
  endOfDay.setMilliseconds(-1);
  return endOfDay;
};

var getStartOfDay = function getStartOfDay(date, options) {
  var _ref2 = options || {},
      timeZoneOffset = _ref2.timeZoneOffset;

  var tzOffset = getTimeZoneOffsetFromLocal(timeZoneOffset);
  var startOfDay = new Date(date);
  startOfDay.setHours(0);
  startOfDay.setMinutes(0 - tzOffset);
  startOfDay.setSeconds(0);
  startOfDay.setMilliseconds(0);
  return startOfDay;
};

var getShortTimeString = function getShortTimeString(hours, minutes) {
  return "" + (hours < 10 ? '0' : '') + (hours || 0) + ":" + (minutes < 10 ? '0' : '') + (minutes || 0);
};

var getDateTimeFromShortTimeString = function getDateTimeFromShortTimeString(value, options) {
  var _ref3 = options || {},
      timeZoneOffset = _ref3.timeZoneOffset;

  var tzOffset = getTimeZoneOffsetFromLocal(timeZoneOffset);
  var date = new Date();

  var _value$split = value.split(':'),
      hours = _value$split[0],
      minutes = _value$split[1];

  date.setHours(parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10) - tzOffset);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

var getLocaleTimeStringFromShortTimeString = function getLocaleTimeStringFromShortTimeString(value, options) {
  var _ref4 = options || {},
      formatTime = _ref4.formatTime,
      locale = _ref4.locale,
      passedOptions = _objectWithoutPropertiesLoose(_ref4, _excluded$3i);

  return typeof formatTime === 'function' ? formatTime(getDateTimeFromShortTimeString(value)) : getDateTimeFromShortTimeString(value).toLocaleTimeString(locale, _extends({
    hour: 'numeric',
    minute: '2-digit'
  }, passedOptions));
};

var guessTimeFromString = function guessTimeFromString(string) {
  var invalidChars = new RegExp('[^\\d:\\spam.]', 'gi');
  var numberRegExp = new RegExp('\\d+');
  var hours = 0;
  var minutes = 0;
  var isPm = false;
  var hasValidUserInput = false;
  var value = string.replace(invalidChars, ' ');

  var _nullSafeMatch = nullSafeMatch(value, numberRegExp),
      content = _nullSafeMatch.content,
      endIndex = _nullSafeMatch.endIndex;

  if (content && parseInt(content, 10) < 24) {
    hours = parseInt(content, 10);
    isPm = hours >= 12;
    value = value.substring(endIndex);
    hasValidUserInput = true;
  }

  var _nullSafeMatch2 = nullSafeMatch(value, numberRegExp);

  content = _nullSafeMatch2.content;
  endIndex = _nullSafeMatch2.endIndex;

  if (content && parseInt(content, 10) < 60) {
    minutes = parseInt(content, 10);
    value = value.substring(endIndex);
    hasValidUserInput = true;
  }

  var amPmRegExp = new RegExp('[ap]', 'i');

  var _nullSafeMatch3 = nullSafeMatch(value, amPmRegExp);

  content = _nullSafeMatch3.content;

  if (content && hours > 0 && hours <= 12) {
    isPm = (content || '').toLowerCase() === 'p';
    hours %= 12;

    if (isPm) {
      hours += 12;
    }

    hasValidUserInput = true;
  }

  var time = getShortTimeString(hours, minutes);
  return hasValidUserInput ? {
    time: time,
    hours: hours,
    minutes: minutes
  } : {};
};

var getTotalMinutes = function getTotalMinutes(timeString) {
  var _split = (timeString || ':').split(':'),
      hours = _split[0],
      minutes = _split[1];

  var totalMinutes = parseInt(hours, 10) * 60 + parseInt(minutes, 10);
  return !Number.isNaN(totalMinutes) ? totalMinutes : undefined;
};

var getInputTimeMinMaxValidationMessagePolyfill = function getInputTimeMinMaxValidationMessagePolyfill(_ref5) {
  var max = _ref5.max,
      min = _ref5.min,
      value = _ref5.value;
  var validationMessage = '';
  var totalMinutes = getTotalMinutes(value || ':');
  var maxTotalMinutes = getTotalMinutes(max);
  var minTotalMinutes = getTotalMinutes(min);

  if (typeof totalMinutes !== 'number') {
    return validationMessage;
  }

  if (typeof maxTotalMinutes === 'number' && totalMinutes > maxTotalMinutes) {
    validationMessage = "Value must be " + max + " or earlier.";
  }

  if (typeof minTotalMinutes === 'number' && totalMinutes < minTotalMinutes) {
    validationMessage = "Value must be " + min + " or later.";
  }

  return validationMessage;
};

var SECONDS_PER_MINUTE = 60;
var SECONDS_PER_HOUR = SECONDS_PER_MINUTE * 60;
var SECONDS_PER_DAY = SECONDS_PER_HOUR * 24;
var styles$o = {
  "icon": "rvr-icon__1Rb",
  "toggle": "rvr-toggle__1ph",
  "menu": "rvr-menu__2vq",
  "menuItem": "rvr-menuItem__8cf"
};

var Dropdown$1 = function Dropdown(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      disabled = _ref.disabled,
      formatTime = _ref.formatTime,
      max = _ref.max,
      menuProps = _ref.menuProps,
      min = _ref.min,
      onSelectMenuItem = _ref.onSelectMenuItem,
      passedProps = _ref.passedProps,
      showDropdown = _ref.showDropdown,
      customStep = _ref.step,
      stepFrom = _ref.stepFrom,
      _ref$toggleAriaLabel = _ref.toggleAriaLabel,
      toggleAriaLabel = _ref$toggleAriaLabel === void 0 ? 'Toggle time dropdown' : _ref$toggleAriaLabel,
      toggleProps = _ref.toggleProps,
      value = _ref.value;
  var menuItems = React.useMemo(function () {
    if (!showDropdown) {
      return [];
    }

    var step = customStep || 0;

    if (!step || Number.isNaN(step) || step < SECONDS_PER_MINUTE * 10 || step > SECONDS_PER_DAY) {
      step = 0;
    }

    if (!step) {
      var _ref2, _value$split;

      var currentMinute = parseInt((_ref2 = value && ((_value$split = value.split(':')) === null || _value$split === void 0 ? void 0 : _value$split[1])) != null ? _ref2 : '00', 10);
      step = [10, 15, 30].reduce(function (result, increment) {
        if (currentMinute && currentMinute % increment === 0) {
          result = increment * SECONDS_PER_MINUTE;
        }

        return result;
      }, SECONDS_PER_HOUR);
    }

    var current = stepFrom && getDateTimeFromShortTimeString(stepFrom) || getStartOfDay(new Date());
    var end = getEndOfDay(new Date());
    var maxAttempts = (SECONDS_PER_HOUR + SECONDS_PER_DAY) / (SECONDS_PER_MINUTE * 10);
    var maxDate = max ? getDateTimeFromShortTimeString(max) : undefined;
    var minDate = min ? getDateTimeFromShortTimeString(min) : undefined;
    var attempts = 0;
    var options = [];

    do {
      attempts += 1;
      var label = typeof formatTime === 'function' ? formatTime(current) : current.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit'
      });

      if ((maxDate === undefined || current <= maxDate) && (minDate === undefined || current >= minDate)) {
        (function () {
          var currentCopy = new Date(current.valueOf());
          options.push({
            className: styles$o.menuItem,
            label: label,
            onClick: function onClick() {
              return onSelectMenuItem({
                target: {
                  value: currentCopy
                }
              });
            }
          });
        })();
      }

      current.setSeconds(current.getSeconds() + step);
    } while (attempts <= maxAttempts && current < end);

    return options;
  }, [customStep, formatTime, max, min, onSelectMenuItem, showDropdown, stepFrom, value]);
  return (
    /*#__PURE__*/
    React__default.createElement(EasyDropdown, Object.assign({
      className: classNames(className, styles$o.Dropdown),
      defaultIsOpen: false,
      disabled: disabled,
      isOpen: undefined,
      menuItems: menuItems,
      menuProps: _extends({
        className: styles$o.menu,
        position: 'bottomLeft'
      }, menuProps),
      onToggle: function onToggle() {},
      toggleProps: toggleProps
    }, passedProps),
    /*#__PURE__*/
    React__default.createElement(Button, {
      "aria-label": toggleAriaLabel,
      className: styles$o.toggle,
      disabled: disabled,
      level: "text",
      size: "sm"
    },
    /*#__PURE__*/
    React__default.createElement(Icon, {
      fill: "currentColor",
      name: "arrow-drop-down",
      style: {
        display: 'block'
      }
    })))
  );
};

var styles$p = {
  "InputTime": "rvr-InputTime__2md",
  "Input": "rvr-Input__1dY",
  "addons": "rvr-addons__gB-",
  "icon": "rvr-icon__120",
  "disabledIcon": "rvr-disabledIcon__3-p"
};
var _excluded$3j = ["className", "disabled", "dropdownProps", "fauxDisabled", "formatTime", "forwardedRef", "fuzzyInputProps", "max", "min", "onChange", "showDropdown", "step", "toggleAriaLabel", "value"];

var AsString = function AsString(_ref) {
  var _classNames, _classNames2;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      disabled = _ref.disabled,
      dropdownProps = _ref.dropdownProps,
      fauxDisabled = _ref.fauxDisabled,
      formatTime = _ref.formatTime,
      forwardedRef = _ref.forwardedRef,
      _ref$fuzzyInputProps = _ref.fuzzyInputProps,
      fuzzyInputProps = _ref$fuzzyInputProps === void 0 ? {} : _ref$fuzzyInputProps,
      max = _ref.max,
      min = _ref.min,
      onChange = _ref.onChange,
      _ref$showDropdown = _ref.showDropdown,
      customShowDropdown = _ref$showDropdown === void 0 ? 'click' : _ref$showDropdown,
      customStep = _ref.step,
      toggleAriaLabel = _ref.toggleAriaLabel,
      valueOrUndefined = _ref.value,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3j);

  var localRef = React.useRef(null);
  var shadowTimeInputRef = React.useRef(null);
  React.useImperativeHandle(forwardedRef, function () {
    return localRef.current;
  });

  var _useState = React.useState(false),
      focus = _useState[0],
      setFocus = _useState[1];

  var _useState2 = React.useState(true),
      validity = _useState2[0],
      setValidity = _useState2[1];

  var showDropdown = customShowDropdown === 'click' ? 'click' : undefined;
  var value = React.useMemo(function () {
    return valueOrUndefined || '';
  }, [valueOrUndefined]);
  var step = React.useMemo(function () {
    var safeStep = parseInt(customStep, 10);

    if (!safeStep || Number.isNaN(safeStep) || safeStep < SECONDS_PER_MINUTE || safeStep > SECONDS_PER_DAY) {
      return undefined;
    }

    return safeStep;
  }, [customStep]);
  var dropdownStep = React.useMemo(function () {
    return step && step >= SECONDS_PER_MINUTE * 10 ? step : undefined;
  }, [step]);
  var stepFrom = React.useMemo(function () {
    if (min) {
      return min;
    }

    var start = getStartOfDay(new Date());
    return getShortTimeString(start.getHours(), start.getMinutes());
  }, [min]);

  var _useState3 = React.useState(value ? getLocaleTimeStringFromShortTimeString(value, {
    formatTime: formatTime
  }) : ''),
      fuzzyValue = _useState3[0],
      setFuzzyValue = _useState3[1];

  var syncValidity = React.useCallback(function (refFrom, refTo) {
    if (refTo !== null && refTo !== void 0 && refTo.current && refFrom !== null && refFrom !== void 0 && refFrom.current) {
      var validationMessage = refFrom.current.validationMessage;

      if (refFrom.current.type !== 'time') {
        validationMessage = getInputTimeMinMaxValidationMessagePolyfill({
          value: refFrom.current.value,
          max: max,
          min: min
        });
      }

      refTo.current.setCustomValidity(validationMessage);
      setValidity(!validationMessage);
    }
  }, [max, min]);
  var changeShadowTimeInput = React.useCallback(function (nextValue) {
    if (nextValue && nextValue !== value && shadowTimeInputRef.current) {
      handleDispatchNativeInputChange(shadowTimeInputRef.current, nextValue);
    }
  }, [shadowTimeInputRef, value]);

  var handleChangeFuzzyValue = function handleChangeFuzzyValue(e) {
    setFuzzyValue(e.target.value);

    if (e.target.value) {
      var _guessTimeFromString = guessTimeFromString(e.target.value),
          nextValue = _guessTimeFromString.time;

      changeShadowTimeInput(nextValue);
    }
  };

  var handleFocus = function handleFocus() {
    return setFocus(true);
  };

  var handleBlur = function handleBlur() {
    return setFocus(false);
  };

  var handleClickClockIcon = function handleClickClockIcon() {
    if (localRef.current) {
      localRef.current.focus();
    }
  };

  var handleBlurFuzzyValue = function handleBlurFuzzyValue() {
    setFuzzyValue(value ? getLocaleTimeStringFromShortTimeString(value, {
      formatTime: formatTime
    }) : '');
  };

  var handleSelectMenuItem = function handleSelectMenuItem(e) {
    var dateTime = e.target.value;
    var label = typeof formatTime === 'function' ? formatTime(dateTime) : dateTime.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit'
    });
    var timeString = getShortTimeString(dateTime.getHours(), dateTime.getMinutes());
    setFuzzyValue(label);
    changeShadowTimeInput(timeString);
    setFocus(false);
  };

  React.useEffect(function () {
    if (shadowTimeInputRef.current) {
      handleDispatchNativeInputChange(shadowTimeInputRef.current, value);
    }

    if (localRef !== null && localRef !== void 0 && localRef.current && document.activeElement !== (localRef === null || localRef === void 0 ? void 0 : localRef.current)) {
      setFuzzyValue(value ? getLocaleTimeStringFromShortTimeString(value, {
        formatTime: formatTime
      }) : '');
    }

    syncValidity(shadowTimeInputRef, localRef);
  }, [formatTime, localRef, shadowTimeInputRef, step, syncValidity, value]);
  React.useEffect(function () {
    syncValidity(shadowTimeInputRef, localRef);
  }, [localRef, max, min, shadowTimeInputRef, syncValidity]);
  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      className: classNames(styles$p.InputTime, inputStyles.Input, className, (_classNames = {}, _classNames[inputStyles.disabled] = disabled, _classNames[inputStyles.invalid] = !validity, _classNames[inputStyles.focus] = focus, _classNames)),
      onFocus: handleFocus,
      onBlur: handleBlur
    }, passedProps),
    /*#__PURE__*/
    React__default.createElement(Input$1, Object.assign({
      className: styles$p.Input,
      disabled: disabled,
      fauxDisabled: fauxDisabled,
      onBlur: handleBlurFuzzyValue,
      onChange: handleChangeFuzzyValue,
      ref: localRef,
      value: fuzzyValue
    }, fuzzyInputProps)),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$p.addons
    },
    /*#__PURE__*/
    React__default.createElement(Icon, {
      className: classNames(styles$p.icon, (_classNames2 = {}, _classNames2[styles$p.disabledIcon] = disabled || fauxDisabled, _classNames2)),
      fill: "currentColor",
      height: 16,
      name: "clock",
      onClick: handleClickClockIcon,
      width: 16
    }), showDropdown &&
    /*#__PURE__*/
    React__default.createElement(Dropdown$1, Object.assign({
      className: styles$p.dropdown,
      disabled: disabled || fauxDisabled,
      formatTime: formatTime,
      max: max,
      min: min,
      onSelectMenuItem: handleSelectMenuItem,
      showDropdown: showDropdown,
      step: dropdownStep,
      stepFrom: stepFrom,
      toggleAriaLabel: toggleAriaLabel,
      value: value
    }, dropdownProps))),
    /*#__PURE__*/
    React__default.createElement("input", {
      max: max,
      min: min,
      onChange: onChange || function () {},
      ref: shadowTimeInputRef,
      step: step,
      style: {
        display: 'none'
      },
      tabIndex: -1,
      type: "time"
    }))
  );
};

var _excluded$3k = ["disabled", "forwardedRef", "max", "min", "onChange", "value"];

var AsDate = function AsDate(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      forwardedRef = _ref.forwardedRef,
      maxDateString = _ref.max,
      minDateString = _ref.min,
      onChange = _ref.onChange,
      valueDateString = _ref.value,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3k);

  var _useState = React.useState(false),
      invalidMax = _useState[0],
      setInvalidMax = _useState[1];

  var _useState2 = React.useState(false),
      invalidMin = _useState2[0],
      setInvalidMin = _useState2[1];

  React.useEffect(function () {
    if (maxDateString && Number.isNaN(new Date(maxDateString).valueOf())) {
      console.warn('`max` should be an ISO date string when using `InputTime` with dates');
    }

    if (minDateString && Number.isNaN(new Date(minDateString).valueOf())) {
      console.warn('`min` should be an ISO date string when using `InputTime` with dates');
    }

    if (valueDateString && Number.isNaN(new Date(valueDateString).valueOf())) {
      console.warn('`value` should be an ISO date string when using `InputTime` with dates');
    }
  });
  var localRef = React.useRef(null);
  var shadowDateTimeInputRef = React.useRef(null);
  React.useImperativeHandle(forwardedRef, function () {
    return localRef.current;
  });
  var max = React.useMemo(function () {
    var maxDate = new Date(maxDateString || '');
    var valueDate = new Date(valueDateString || '');
    setInvalidMax(false);

    if (Number.isNaN(maxDate.valueOf()) || Number.isNaN(valueDate.valueOf()) || maxDate > getEndOfDay(valueDate)) {
      return '';
    }

    if (maxDate < getStartOfDay(valueDate)) {
      setInvalidMax(true);
      return '';
    }

    return getShortTimeString(maxDate.getHours(), maxDate.getMinutes());
  }, [maxDateString, valueDateString]);
  var min = React.useMemo(function () {
    var minDate = new Date(minDateString || '');
    var valueDate = new Date(valueDateString || '');
    setInvalidMin(false);

    if (Number.isNaN(minDate.valueOf()) || Number.isNaN(valueDate.valueOf()) || minDate < getStartOfDay(valueDate)) {
      return '';
    }

    if (minDate > getEndOfDay(valueDate)) {
      setInvalidMin(true);
      return '';
    }

    return getShortTimeString(minDate.getHours(), minDate.getMinutes());
  }, [minDateString, valueDateString]);
  var value = React.useMemo(function () {
    var valueDate = new Date(valueDateString || '');

    if (Number.isNaN(valueDate.valueOf())) {
      return '';
    }

    return getShortTimeString(valueDate.getHours(), valueDate.getMinutes());
  }, [valueDateString]);

  var handleChangeString = function handleChangeString(e) {
    if (!onChange) {
      return;
    }

    var nextDate = new Date(valueDateString || '');
    nextDate = Number.isNaN(nextDate.valueOf()) ? new Date() : nextDate;

    if (e.target.value) {
      var _e$target$value$split = e.target.value.split(':'),
          hoursString = _e$target$value$split[0],
          minutesString = _e$target$value$split[1];

      nextDate.setHours(parseInt(hoursString, 10));
      nextDate.setMinutes(parseInt(minutesString, 10));
      nextDate.setSeconds(0);
      nextDate.setMilliseconds(0);
      var nextDateString = nextDate.toISOString();

      if (nextDateString !== valueDateString && shadowDateTimeInputRef.current) {
        handleDispatchNativeInputChange(shadowDateTimeInputRef.current, nextDateString);
      }
    }
  };

  return (
    /*#__PURE__*/
    React__default.createElement(React.Fragment, null,
    /*#__PURE__*/
    React__default.createElement(AsString, Object.assign({}, passedProps, {
      disabled: invalidMax || invalidMin || disabled,
      forwardedRef: localRef,
      max: max,
      min: min,
      onChange: handleChangeString,
      value: value
    })),
    /*#__PURE__*/
    React__default.createElement("input", {
      onChange: onChange || function () {},
      ref: shadowDateTimeInputRef,
      style: {
        display: 'none'
      },
      tabIndex: -1
    }))
  );
};

var _excluded$3l = ["max", "min", "value"];

var InputTime = function InputTime(_ref) {
  var max = _ref.max,
      min = _ref.min,
      value = _ref.value,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3l);

  var maxDate = max ? new Date(max) : undefined;
  var minDate = min ? new Date(min) : undefined;
  var valueDate = value ? new Date(value) : undefined;

  if (valueDate && !Number.isNaN(valueDate.valueOf())) {
    var _maxDate$toISOString, _minDate$toISOString, _valueDate$toISOStrin;

    return (
      /*#__PURE__*/
      React__default.createElement(AsDate, Object.assign({}, passedProps, {
        max: (_maxDate$toISOString = maxDate === null || maxDate === void 0 ? void 0 : maxDate.toISOString()) != null ? _maxDate$toISOString : undefined,
        min: (_minDate$toISOString = minDate === null || minDate === void 0 ? void 0 : minDate.toISOString()) != null ? _minDate$toISOString : undefined,
        value: (_valueDate$toISOStrin = valueDate === null || valueDate === void 0 ? void 0 : valueDate.toISOString()) != null ? _valueDate$toISOStrin : undefined
      }))
    );
  }

  return (
    /*#__PURE__*/
    React__default.createElement(AsString, Object.assign({}, passedProps, {
      max: max,
      min: min,
      value: value
    }))
  );
};

var InputTime$1 =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(InputTime, Object.assign({}, props, {
      forwardedRef: ref || undefined
    }))
  );
});
var styles$q = {
  "color--primary": "rvr-color--primary__1Lh",
  "color--primary-alt": "rvr-color--primary-alt__2Gu",
  "color--black": "rvr-color--black__23h",
  "size--sm": "rvr-size--sm__3I_",
  "size--md": "rvr-size--md__237",
  "size--lg": "rvr-size--lg__13V",
  "size--xl": "rvr-size--xl__3fm",
  "size--xl2": "rvr-size--xl2__gby",
  "size--xl3": "rvr-size--xl3__3DI",
  "weight--normal": "rvr-weight--normal__3EJ",
  "weight--bold": "rvr-weight--bold__1I8"
};
var _excluded$3m = ["color", "className", "size", "tag", "weight"];

var Typography = function Typography(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$className = _ref.className,
      passedClassName = _ref$className === void 0 ? '' : _ref$className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? 'normal' : _ref$weight,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3m);

  var className = React.useMemo(function () {
    var _classNames;

    return classNames((_classNames = {}, _classNames[styles$q["color--" + color]] = color, _classNames[styles$q["weight--" + weight]] = weight, _classNames[styles$q["size--" + size]] = size, _classNames), passedClassName);
  }, [color, passedClassName, weight, size]);
  return (
    /*#__PURE__*/
    React__default.createElement(Tag, Object.assign({}, props, {
      className: className
    }))
  );
};

var TypographyBlock = function TypographyBlock(props) {
  return (
    /*#__PURE__*/
    React__default.createElement(Typography, Object.assign({
      Tag: "div"
    }, props))
  );
};

Typography.Block = TypographyBlock;
var styles$r = {
  "Modal": "rvr-Modal__3K7",
  "enterDone": "rvr-enterDone__3tQ",
  "exit": "rvr-exit__3xt",
  "content": "rvr-content__ocM",
  "Header": "rvr-Header__1pt",
  "level--primary": "rvr-level--primary__-kd",
  "level--warning": "rvr-level--warning__3Jk",
  "level--info": "rvr-level--info__2RD",
  "level--danger": "rvr-level--danger__zG9",
  "Footer": "rvr-Footer__29t",
  "Body": "rvr-Body__1Bf",
  "bodyHasOpenModal": "rvr-bodyHasOpenModal__2-5",
  "sm": "rvr-sm__246",
  "md": "rvr-md__2ns",
  "lg": "rvr-lg__KZb"
};
var _excluded$3n = ["children", "className", "isOpen", "onClose", "size", "style"],
    _excluded2$4 = ["children", "className", "level"],
    _excluded3$2 = ["children", "className"],
    _excluded4$1 = ["children", "className"];
var modalRef =
/*#__PURE__*/
React.createRef();
var modalContext =
/*#__PURE__*/
React.createContext({
  onClose: function onClose() {}
});

var getFocusableElements = function getFocusableElements(element) {
  return element === null || element === void 0 ? void 0 : element.querySelectorAll('a, button, textarea, input, input[type="radio"], input[type="checkbox"], select');
};

var getFirstFocusableElement = function getFirstFocusableElement(element) {
  var focusableElements = getFocusableElements(element);
  return focusableElements && focusableElements[0];
};

var getLastFocusableElement = function getLastFocusableElement(element) {
  var focusableElements = getFocusableElements(element);
  return focusableElements && focusableElements[focusableElements.length - 1];
};

var Modal = function Modal(_ref) {
  var _classNames;

  var children = _ref.children,
      _ref$className = _ref.className,
      passedClassName = _ref$className === void 0 ? '' : _ref$className,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$style = _ref.style,
      passedStyle = _ref$style === void 0 ? {} : _ref$style,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3n);

  var handleEscape = React.useCallback(function (e) {
    if (isOpen && e.code === 'Escape' && onClose) {
      var _modalRef$current;

      if (!(modalRef !== null && modalRef !== void 0 && (_modalRef$current = modalRef.current) !== null && _modalRef$current !== void 0 && _modalRef$current.contains(document.activeElement))) {
        onClose();
      }

      document.activeElement.blur();
    }
  }, [isOpen, onClose]);
  var handleTabKey = React.useCallback(function (e) {
    var focusableElements = getFocusableElements(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current);

    if (focusableElements) {
      var firstFocusableElement = getFirstFocusableElement(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current);
      var lastFocusableElement = getLastFocusableElement(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current);

      if (!e.shiftKey && document.activeElement === lastFocusableElement) {
        firstFocusableElement === null || firstFocusableElement === void 0 ? void 0 : firstFocusableElement.focus();
        return e.preventDefault();
      }

      if (e.shiftKey && document.activeElement === firstFocusableElement) {
        lastFocusableElement === null || lastFocusableElement === void 0 ? void 0 : lastFocusableElement.focus();
        return e.preventDefault();
      }
    }

    return null;
  }, []);
  React.useEffect(function () {
    var keyListenerMap = new Map([['Escape', handleEscape], ['Tab', handleTabKey]]);

    var keyListener = function keyListener(e) {
      var listener = keyListenerMap.get(e.code);
      return listener && listener(e);
    };

    if (isOpen) {
      window.addEventListener('keydown', keyListener);
    }

    if (!isOpen) {
      window.removeEventListener('keydown', keyListener);
    }

    return function () {
      if (isOpen) window.removeEventListener('keydown', keyListener);
    };
  }, [handleEscape, handleTabKey, isOpen]);
  React.useEffect(function () {
    if (isOpen) {
      document.body.className = classNames(document.body.className, styles$r.bodyHasOpenModal);
      var firstElement = getFirstFocusableElement(modalRef === null || modalRef === void 0 ? void 0 : modalRef.current);
      firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
    } else {
      document.body.className = document.body.className.replace(styles$r.bodyHasOpenModal, '').trim();
    }
  }, [isOpen]);
  var modalContentStyle = classNames(styles$r.content, (_classNames = {}, _classNames[styles$r[size]] = size, _classNames), passedClassName);

  var handleClickBackdrop = function handleClickBackdrop(e) {
    var _modalRef$current2;

    if (e.target && modalRef !== null && modalRef !== void 0 && (_modalRef$current2 = modalRef.current) !== null && _modalRef$current2 !== void 0 && _modalRef$current2.contains(e.target)) {
      return;
    }

    onClose();
  };

  return (
    /*#__PURE__*/
    ReactDOM.createPortal(
    /*#__PURE__*/
    React__default.createElement(CSSTransition, {
      "in": isOpen,
      unmountOnExit: true,
      timeout: {
        enter: 0,
        exit: 300
      },
      classNames: {
        enterDone: styles$r.enterDone,
        exit: styles$r.exit
      }
    },
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      role: "presentation"
    }, passedProps, {
      style: passedStyle,
      className: styles$r.Modal,
      onClick: handleClickBackdrop
    }),
    /*#__PURE__*/
    React__default.createElement("div", {
      role: "dialog",
      className: modalContentStyle,
      ref: modalRef
    },
    /*#__PURE__*/
    React__default.createElement(modalContext.Provider, {
      value: {
        onClose: onClose
      }
    }, children)))), document.body)
  );
};

var Header$2 = function Header(_ref2) {
  var _classNames2;

  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$level = _ref2.level,
      level = _ref2$level === void 0 ? 'primary' : _ref2$level,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$4);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$r.Header, (_classNames2 = {}, _classNames2[styles$r["level--" + level]] = level, _classNames2), className)
    }), children)
  );
};

var Body$2 = function Body(_ref3) {
  var children = _ref3.children,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3$2);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$r.Body, className)
    }), children)
  );
};

var Footer$1 = function Footer(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4$1);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$r.Footer, className)
    }), children)
  );
};

Modal.Header = Header$2;
Modal.Body = Body$2;
Modal.Footer = Footer$1;
var styles$s = {
  "Kite": "rvr-Kite__38Y",
  "slide-in-right": "rvr-slide-in-right__3rl",
  "visible": "rvr-visible__3rw",
  "icon": "rvr-icon__2jf",
  "content": "rvr-content__yak",
  "dismissButton": "rvr-dismissButton__3XY",
  "header": "rvr-header__2X2",
  "body": "rvr-body__UZG",
  "title": "rvr-title__2ID",
  "enterDone": "rvr-enterDone__mkz",
  "exit": "rvr-exit__3oh",
  "top-right": "rvr-top-right__3Be"
};
var _excluded$3o = ["canBeDismissed", "children", "className", "visible", "icon", "onClose", "ttl"],
    _excluded2$5 = ["className"],
    _excluded3$3 = ["className"],
    _excluded4$2 = ["className"];

var Kite = function Kite(_ref) {
  var _classNames;

  var _ref$canBeDismissed = _ref.canBeDismissed,
      canBeDismissed = _ref$canBeDismissed === void 0 ? true : _ref$canBeDismissed,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? undefined : _ref$children,
      _ref$className = _ref.className,
      passedClassName = _ref$className === void 0 ? '' : _ref$className,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? undefined : _ref$icon,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$ttl = _ref.ttl,
      ttl = _ref$ttl === void 0 ? undefined : _ref$ttl,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3o);

  React.useEffect(function () {
    var interval = setInterval(function () {
      if (onClose && ttl) {
        onClose();
      }
    }, ttl);
    return function () {
      clearInterval(interval);
    };
  }, [onClose, ttl]);
  return (
    /*#__PURE__*/
    ReactDOM.createPortal(
    /*#__PURE__*/
    React__default.createElement(CSSTransition, {
      "in": visible,
      unmountOnExit: true,
      timeout: {
        enter: 0,
        exit: 300
      },
      classNames: {
        enterDone: styles$s.enterDone,
        exit: styles$s.exit
      }
    },
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({
      className: classNames(styles$s.Kite, (_classNames = {}, _classNames[styles$s.visible] = visible, _classNames), passedClassName)
    }, passedProps), icon &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$s.icon
    }, icon),
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$s.content
    }, children), canBeDismissed &&
    /*#__PURE__*/
    React__default.createElement("div", {
      className: styles$s.dismissButton
    },
    /*#__PURE__*/
    React__default.createElement(Button, {
      level: "text",
      onClick: onClose,
      "data-testid": "kite-dismiss-button"
    },
    /*#__PURE__*/
    React__default.createElement(Button.Addon, null,
    /*#__PURE__*/
    React__default.createElement(Icon, {
      height: "20",
      name: "close",
      style: {
        display: 'block'
      },
      width: "20"
    })))))), document.body)
  );
};

var KiteIcon = function KiteIcon(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2$5);

  return (
    /*#__PURE__*/
    React__default.createElement(Icon, Object.assign({}, props, {
      className: classNames(styles$s.icon, className)
    }))
  );
};

var KiteHeader = function KiteHeader(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3$3);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$s.header, className)
    }))
  );
};

var KiteBody = function KiteBody(_ref4) {
  var className = _ref4.className,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4$2);

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, props, {
      className: classNames(styles$s.body, className)
    }))
  );
};

Kite.Icon = KiteIcon;
Kite.Header = KiteHeader;
Kite.Body = KiteBody;
var styles$t = {
  "Loader": "rvr-Loader__2eb",
  "LOADERRIPPLE": "rvr-LOADERRIPPLE__13B",
  "sm": "rvr-sm__1M0",
  "md": "rvr-md__Qqi",
  "lg": "rvr-lg__1wW",
  "xl": "rvr-xl__11b"
};
var _excluded$3p = ["size"];

var Loader = function Loader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'lg' : _ref$size,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$3p);

  var mainClass = classNames(styles$t.Loader, rest.className, "" + styles$t[size]);

  var prop = _extends({}, rest, {
    className: mainClass
  });

  return (
    /*#__PURE__*/
    React__default.createElement("div", Object.assign({}, prop))
  );
};

var styles$u = {
  "Select": "rvr-Select__7It",
  "toggle": "rvr-toggle__i8C",
  "placeholder": "rvr-placeholder__1fg",
  "menu": "rvr-menu__eft"
};
var styles$v = {
  "Toggle": "rvr-Toggle__M-x",
  "label": "rvr-label__3X7",
  "icon": "rvr-icon__3Zy",
  "placeholder": "rvr-placeholder__3V7"
};
var _excluded$3q = ["className", "isDisabled", "isInvalid", "isOpen", "isPlaceholder", "label", "forwardedRef"];

var Toggle$1 = function Toggle(_ref) {
  var _classNames;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isInvalid = _ref.isInvalid,
      isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      _ref$isPlaceholder = _ref.isPlaceholder,
      isPlaceholder = _ref$isPlaceholder === void 0 ? false : _ref$isPlaceholder,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$forwardedRef = _ref.forwardedRef,
      forwardedRef = _ref$forwardedRef === void 0 ? undefined : _ref$forwardedRef,
      passedProps = _objectWithoutPropertiesLoose(_ref, _excluded$3q);

  return (
    /*#__PURE__*/
    React__default.createElement("button", Object.assign({
      "aria-expanded": isOpen,
      "aria-haspopup": "listbox",
      className: classNames(inputStyles.Input, styles$v.Toggle, className, (_classNames = {}, _classNames[inputStyles.disabled] = isDisabled, _classNames[inputStyles.invalid] = isInvalid, _classNames[styles$v.placeholder] = isPlaceholder, _classNames)),
      ref: forwardedRef
    }, passedProps, {
      disabled: isDisabled,
      type: "button"
    }),
    /*#__PURE__*/
    React__default.createElement("span", {
      className: styles$v.label
    }, label),
    /*#__PURE__*/
    React__default.createElement(Icon, {
      className: styles$v.icon,
      name: "arrow-drop-down"
    }))
  );
};

Toggle$1.defaultProps = {
  forwardedRef: undefined
};
var Toggle$2 =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(Toggle$1, Object.assign({}, props, {
      forwardedRef: ref
    }))
  );
});

var getEnabledMenuItems = function getEnabledMenuItems(menuItems) {
  return menuItems.filter(function (item) {
    return !item.disabled;
  });
};

var getFocusedMenuItem = function getFocusedMenuItem(menuItems) {
  return menuItems.find(function (item) {
    var _item$forwardedRef;

    return ((_item$forwardedRef = item.forwardedRef) === null || _item$forwardedRef === void 0 ? void 0 : _item$forwardedRef.current) === document.activeElement;
  });
};

var itemNavigationKeyMap = {
  ArrowUp: -1,
  ArrowDown: +1
};

function useMenuArrowKeys(menuItems) {
  var handleKey = React.useCallback(function (e) {
    var key = e.key;
    if (!itemNavigationKeyMap[key]) return;
    var focusedMenuItem = getFocusedMenuItem(menuItems);
    var enabledItems = getEnabledMenuItems(menuItems);
    if (enabledItems.length < 1) return;
    if (!focusedMenuItem) return;
    var prevSelectionIndex = enabledItems.indexOf(focusedMenuItem);
    var selectionIndex = prevSelectionIndex;
    selectionIndex += itemNavigationKeyMap[key];
    selectionIndex = Math.max(0, selectionIndex);
    selectionIndex = Math.min(enabledItems.length - 1, selectionIndex);

    if (selectionIndex !== prevSelectionIndex) {
      var _enabledItems$selecti, _enabledItems$selecti2;

      (_enabledItems$selecti = enabledItems[selectionIndex].forwardedRef) === null || _enabledItems$selecti === void 0 ? void 0 : (_enabledItems$selecti2 = _enabledItems$selecti.current) === null || _enabledItems$selecti2 === void 0 ? void 0 : _enabledItems$selecti2.focus();
    }

    e.preventDefault();
    e.stopPropagation();
  }, [menuItems]);
  return handleKey;
}

var useSuppressFocusEvents = function useSuppressFocusEvents() {
  var transitioning = React.useRef(false);
  var setIsFocusing = React.useCallback(function (value) {
    transitioning.current = value;
  }, []);
  var shouldSuppress = React.useCallback(function (e) {
    return transitioning.current || e.currentTarget.contains(e.relatedTarget);
  }, []);
  return {
    shouldSuppress: shouldSuppress,
    setIsFocusing: setIsFocusing
  };
};

var _excluded$3r = ["children", "value"],
    _excluded2$6 = ["autoFocus", "children", "className", "defaultValue", "disabled", "fauxDisabled", "id", "menuProps", "nativeSelectRef", "onBlur", "onChange", "onFocus", "placeholder", "position", "required", "toggleRef"];

var parseOptionProps = function parseOptionProps(_ref) {
  var _ref$props = _ref.props;
  _ref$props = _ref$props === void 0 ? {} : _ref$props;

  var children = _ref$props.children,
      value = _ref$props.value,
      passedProps = _objectWithoutPropertiesLoose(_ref$props, _excluded$3r);

  return !value && !children ? null : _extends({}, passedProps, {
    children: children,
    label: typeof children === 'string' && children || value,
    value: value
  });
};

var getItemSelectionValue = function getItemSelectionValue(item) {
  return typeof item.value === 'string' ? item.value : item.label;
};

var getDoesItemMatchValue = function getDoesItemMatchValue(_ref2) {
  var item = _ref2.item,
      value = _ref2.value;
  return value === getItemSelectionValue(item);
};

var makeMenuItemConfigFromChild = function makeMenuItemConfigFromChild(_ref3) {
  var handleSelectOption = _ref3.handleSelectOption,
      value = _ref3.value;
  return function (item) {
    var itemSelectionValue = getItemSelectionValue(item);
    return _extends({}, item, {
      onSelect: undefined,
      'aria-selected': getDoesItemMatchValue({
        item: item,
        value: value
      }),
      forwardedRef:
      /*#__PURE__*/
      React__default.createRef(),
      role: 'option',
      value: itemSelectionValue,
      onClick: function onClick() {
        return handleSelectOption(itemSelectionValue);
      }
    });
  };
};

var Select = function Select(_ref4) {
  var _ref4$autoFocus = _ref4.autoFocus,
      autoFocus = _ref4$autoFocus === void 0 ? false : _ref4$autoFocus,
      _ref4$children = _ref4.children,
      children = _ref4$children === void 0 ? undefined : _ref4$children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      defaultValue = _ref4.defaultValue,
      _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
      _ref4$fauxDisabled = _ref4.fauxDisabled,
      fauxDisabled = _ref4$fauxDisabled === void 0 ? false : _ref4$fauxDisabled,
      _ref4$id = _ref4.id,
      unsafeId = _ref4$id === void 0 ? '' : _ref4$id,
      menuProps = _ref4.menuProps,
      forwardedNativeSelectRef = _ref4.nativeSelectRef,
      onBlur = _ref4.onBlur,
      onChange = _ref4.onChange,
      onFocus = _ref4.onFocus,
      _ref4$placeholder = _ref4.placeholder,
      placeholder = _ref4$placeholder === void 0 ? 'Choose something' : _ref4$placeholder,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? 'bottom' : _ref4$position,
      _ref4$required = _ref4.required,
      required = _ref4$required === void 0 ? false : _ref4$required,
      forwardedToggleRef = _ref4.toggleRef,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded2$6);

  var _useState = React.useState(false),
      isInvalid = _useState[0],
      setIsInvalid = _useState[1];

  var _useState2 = React.useState(''),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = React.useState(false),
      isOpen = _useState3[0],
      setIsOpen = _useState3[1];

  var nativeSelectRef = React.useRef(null);
  var toggleRef = React.useRef(null);
  React.useImperativeHandle(forwardedNativeSelectRef, function () {
    return nativeSelectRef.current;
  });
  React.useImperativeHandle(forwardedToggleRef, function () {
    return toggleRef.current;
  });
  React.useEffect(function () {
    if (defaultValue !== undefined) setValue(defaultValue);
  }, [defaultValue]);

  var _useSuppressFocusEven = useSuppressFocusEvents(),
      setIsFocusing = _useSuppressFocusEven.setIsFocusing,
      shouldSuppressFocusEvents = _useSuppressFocusEven.shouldSuppress;

  var handleBlur = React.useCallback(function (e) {
    if (!onBlur) return;
    if (shouldSuppressFocusEvents(e)) return;
    onBlur(e);
  }, [onBlur, shouldSuppressFocusEvents]);
  var handleFocus = React.useCallback(function (e) {
    if (!onFocus) return;
    if (shouldSuppressFocusEvents(e)) return;
    onFocus(e);
  }, [onFocus, shouldSuppressFocusEvents]);
  var handleSelectOption = React.useCallback(function (nextValue) {
    var _toggleRef$current;

    if (!nativeSelectRef.current) return;
    setValue(nextValue);
    setIsFocusing(true);
    (_toggleRef$current = toggleRef.current) === null || _toggleRef$current === void 0 ? void 0 : _toggleRef$current.focus();
    setIsFocusing(false);
  }, [nativeSelectRef, setIsFocusing, toggleRef]);
  React.useEffect(function () {
    if (!nativeSelectRef.current) return;
    var nativeChangeEvent = new Event('change', {
      bubbles: true
    });
    nativeSelectRef.current.value = value;
    setIsInvalid(!nativeSelectRef.current.validity.valid);
    nativeSelectRef.current.dispatchEvent(nativeChangeEvent);

    if (onChange) {
      onChange(nativeSelectRef.current);
    }
  }, [onChange, nativeSelectRef, value]);
  var id = React.useMemo(function () {
    return unsafeId || nanoid.nanoid();
  }, [unsafeId]);
  var menuItemsWithoutPlaceholder = React.useMemo(function () {
    return React.Children.map(children || [], parseOptionProps).filter(Boolean).map(makeMenuItemConfigFromChild({
      handleSelectOption: handleSelectOption,
      value: value
    }));
  }, [children, handleSelectOption, value]);
  var menuItems = React.useMemo(function () {
    return [{
      'aria-selected': value === '',
      className: styles$u.placeholder,
      forwardedRef:
      /*#__PURE__*/
      React__default.createRef(),
      children: placeholder,
      label: typeof placeholder === 'string' ? placeholder : 'Choose something',
      role: 'option',
      value: '',
      onClick: function onClick() {
        return handleSelectOption('');
      }
    }].concat(menuItemsWithoutPlaceholder);
  }, [handleSelectOption, menuItemsWithoutPlaceholder, placeholder, value]);
  var handleToggleOpen = React.useCallback(function (_, nextIsOpen) {
    setIsOpen(nextIsOpen || false);

    if (!nextIsOpen) {
      var _toggleRef$current2;

      setIsFocusing(true);
      toggleRef === null || toggleRef === void 0 ? void 0 : (_toggleRef$current2 = toggleRef.current) === null || _toggleRef$current2 === void 0 ? void 0 : _toggleRef$current2.focus();
      setIsFocusing(false);
      return;
    }

    var firstSelected = menuItems.find(function (item) {
      return getDoesItemMatchValue({
        item: item,
        value: value
      });
    });
    setIsFocusing(true);
    setTimeout(function () {
      var _firstSelected$forwar, _firstSelected$forwar2;

      firstSelected === null || firstSelected === void 0 ? void 0 : (_firstSelected$forwar = firstSelected.forwardedRef) === null || _firstSelected$forwar === void 0 ? void 0 : (_firstSelected$forwar2 = _firstSelected$forwar.current) === null || _firstSelected$forwar2 === void 0 ? void 0 : _firstSelected$forwar2.focus();
      setIsFocusing(false);
    }, 200);
  }, [menuItems, setIsFocusing, toggleRef, value]);
  var handleKeyDown = useMenuArrowKeys(menuItems);
  var selectedItem = React.useMemo(function () {
    return menuItems.find(function (item) {
      return getDoesItemMatchValue({
        item: item,
        value: value
      });
    });
  }, [menuItems, value]);
  var selectionDescriptor = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.children) || (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) || placeholder;
  return (
    /*#__PURE__*/
    React__default.createElement(React.Fragment, null,
    /*#__PURE__*/
    React__default.createElement(EasyDropdown, Object.assign({}, props, {
      className: classNames(styles$u.Select, className),
      defaultIsOpen: false,
      menuItems: menuItems,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onToggle: handleToggleOpen,
      menuProps: _extends({
        role: 'listbox',
        className: styles$u.menu,
        position: position === 'top' ? 'topRight' : 'bottomRight'
      }, menuProps)
    }),
    /*#__PURE__*/
    React__default.createElement(Toggle$2, {
      autoFocus: autoFocus,
      className: styles$u.toggle,
      id: id,
      isDisabled: disabled || fauxDisabled,
      isInvalid: isInvalid,
      isOpen: isOpen,
      isPlaceholder: !selectedItem || selectedItem.value === '',
      label: selectionDescriptor,
      ref: toggleRef
    })),
    /*#__PURE__*/
    React__default.createElement("select", {
      "aria-hidden": true,
      hidden: true,
      required: required,
      ref: nativeSelectRef
    }, menuItems.map(function (item) {
      return (
        /*#__PURE__*/
        React__default.createElement("option", {
          key: getItemSelectionValue(item),
          value: item.value
        }, item.children)
      );
    })))
  );
};

var WithRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React__default.createElement(Select, Object.assign({}, props, {
      toggleRef: ref
    }))
  );
});
Select.WithRef = WithRef;
var _excluded$3s = ["children", "value"];

var Option = function Option(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      customValue = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3s);

  React.useEffect(function () {
    if (typeof children !== 'string' && !customValue) {
      console.warn('Option requires a `value` prop when `children` is not a string.');
    }
  }, [children, customValue]);
  return (
    /*#__PURE__*/
    React__default.createElement(Dropdown.Menu.Item, Object.assign({}, {}, props), children)
  );
};

exports.Accordion = Accordion;
exports.Avatar = Avatar;
exports.Badge = Badge;
exports.Bar = Bar;
exports.Button = Button;
exports.Callout = Callout;
exports.Checkbox = Checkbox;
exports.Collapse = Collapse;
exports.DeletablePill = DeletablePill;
exports.Dropdown = Dropdown;
exports.EasyDropdown = EasyDropdown;
exports.EasyPill = EasyPill;
exports.EasyRichTooltip = EasyRichTooltip;
exports.EasyTabMenu = EasyTabMenu;
exports.ExpansionPanel = ExpansionPanel;
exports.Grid = Grid;
exports.Icon = Icon;
exports.Input = Input$1;
exports.InputTime = InputTime$1;
exports.Kite = Kite;
exports.Loader = Loader;
exports.Media = Media;
exports.Modal = Modal;
exports.Option = Option;
exports.Paper = Paper$1;
exports.Pill = Pill;
exports.Responsive = Responsive;
exports.Select = Select;
exports.SideTray = SideTray;
exports.SimpleTabMenu = SimpleTabMenu;
exports.TabMenu = TabMenu;
exports.Toggle = Toggle;
exports.Tooltip = Tooltip;
exports.Typography = Typography;
exports.iconsMap = iconsMap;